I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "actions": "Actions",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Address",
        "name": "Name"
      },
      "employee": {
        "active": "Active",
        "admin": "Super-rights",
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "role": "Role"
      },
      "explosive": {
        "available": "Available",
        "box_number": "Box Number",
        "code": "Item Code",
        "delivery_date": "Delivery Date",
        "grouped_number": "Grouped number",
        "import_name": "Imported File Name",
        "item_number": "Item Number",
        "location": "Location",
        "manufacturer": "Manufacturer",
        "middlebox_number": "Package Number",
        "number_type": "Number type",
        "product_name": "Product Name",
        "product_number": "Product Number",
        "reason": "Reason",
        "takeout": "Takeout",
        "unknown_type": "Unknown type"
      },
      "item_setting": {
        "aine_code": "Substance Code",
        "countable_unit": "Countable Unit",
        "countable_units": {
          "units": "Units",
          "weight": "Weight"
        },
        "include_in_waybills": "Include in Waybills",
        "item_count": "Number of Items",
        "item_name_display": "Display Name",
        "item_name_import": "Item Name",
        "manually_created": "Manually Created",
        "set_weight_manually": "Manual Weight",
        "uro_number": "URO Number",
        "waybill_position": "Waybill Position",
        "weight": "Weight"
      },
      "log": {
        "action": "Action",
        "actions": {
          "atgriešana": "Return",
          "dzēšana": "Deletion",
          "izņemšana": "Takeout",
          "korekcija": "Correction",
          "noliktavas pārvietošana": "Warehouse transfer",
          "pievienošana": "Addition",
          "rediģēšana": "Editing",
          "saņemšana": "Data import",
          "starp-objektu pārvietošana": "Inter-object transfer"
        },
        "author": "Performed By",
        "corrected_explosives": "Corrected Explosives",
        "current_destination": "Current Location",
        "date": "Date",
        "destination": "Work Site",
        "destinations": "Work Sites",
        "employee": "Employee",
        "id_number": "ID Number",
        "import_name": "Import File",
        "notes": "Notes",
        "takeout": "Takeout",
        "takeout_waybill": "Takeout Waybill",
        "takeout_waybill_custom_items": "Manual Row in the Takeout Waybill",
        "vehicle": "Vehicle"
      },
      "pdf_code_printout": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "report": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "takeout": {
        "active": "Active?",
        "date": "Date",
        "destination": "Work Site",
        "employee": "Creator",
        "removed": "Removed",
        "vehicle": "Vehicle",
        "waybills": "Waybills"
      },
      "takeout_waybill": {
        "date": "Date",
        "destination": "Site",
        "direction": "Direction",
        "employee": "Employee",
        "initally_edited": "Edited",
        "issuance_person": "Issuance Person",
        "issuer": "Sender",
        "legal_entity": "Legal Entity",
        "number": "Number",
        "receiver": "Receiver",
        "receiving_person": "Receiving Person",
        "route": "Route",
        "scope": "Waybill scope",
        "takeout": "Takeout",
        "to_object": "To Site",
        "vehicle": "Vehicle"
      },
      "takeout_waybill_custom_item": {
        "amount": "Quantity",
        "item_setting": "Item Settings",
        "name": "Name",
        "package_name": "Package",
        "takeout_waybill": "Takeout Waybill",
        "weight": "Weight"
      },
      "user": {
        "confirmation_sent_at": "Confirmation sent at",
        "confirmation_token": "Confirmation token",
        "confirmed_at": "Confirmed at",
        "created_at": "Created at",
        "current_password": "Current password",
        "current_sign_in_at": "Current sign in at",
        "current_sign_in_ip": "Current sign in IP",
        "email": "Email",
        "encrypted_password": "Encrypted password",
        "failed_attempts": "Failed attempts",
        "last_sign_in_at": "Last sign in at",
        "last_sign_in_ip": "Last sign in IP",
        "locked_at": "Locked at",
        "password": "Password",
        "password_confirmation": "Password confirmation",
        "remember_created_at": "Remember created at",
        "remember_me": "Remember me",
        "reset_password_sent_at": "Reset password sent at",
        "reset_password_token": "Reset password token",
        "sign_in_count": "Sign in count",
        "unconfirmed_email": "Unconfirmed email",
        "unlock_token": "Unlock token",
        "updated_at": "Updated at"
      },
      "vehicle": {
        "active": "Active",
        "number_plate": "License Plate"
      },
      "warehouse": {
        "address": "Address",
        "city": "City",
        "country_code": "Country Code",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "name": "Name",
        "responsible_employee": "Responsible Person",
        "zip": "Postal Code"
      }
    },
    "created_at": "Created",
    "errors": {
      "destination": {
        "adress_taken": "Address has already been taken",
        "generic_error": "Error in input data",
        "name_blank": "Name can't be blank"
      },
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Employee already has identical takeout",
        "missing_destinations": "Must have at least one destination"
      },
      "takeout_waybill": {
        "destination_unknown": "Unknown"
      }
    },
    "models": {
      "destination": "Work Site",
      "employee": "Employee",
      "explosive": "Explosive",
      "item_setting": "Item Setting",
      "log": "Activity Log",
      "pdf_code_printout": "PDF Code Printout",
      "report": "Report",
      "takeout": "Explosives Takeout",
      "takeout_waybill": "Waybill",
      "takeout_waybill_custom_item": "Manually Entered Item",
      "user": {
        "one": "User",
        "other": "Users"
      },
      "vehicle": "Vehicle",
      "warehouse": "Warehouse"
    },
    "removed": "Removed",
    "updated_at": "Updated"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Back to login",
        "description": "Choose a new password for your account.",
        "password_confirmation_label": "Confirm new password",
        "password_label": "New password",
        "submit": "Update password",
        "title": "Set your password"
      },
      "new": {
        "back_to_login": "Back to login",
        "description": "Enter your work email to receive a password setup link.",
        "submit": "Send link",
        "title": "Request password link"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "or",
        "email_login_button": "Email login",
        "email_login_title": "Email login with your work email",
        "google_auth": "Log In with Google",
        "password_label": "Password",
        "password_link_text": "Request password link",
        "remember_me": "Remember me",
        "title": "Log In to BALROCK Warehouse Management"
      }
    }
  },
  "back": "Back",
  "cancel": "Cancel",
  "controllers": {
    "application": {
      "not_logged_in": "You must log in to view the requested page!",
      "not_permitted": "You do not have permission to view the requested page!",
      "report_ready": "Your report: %{report_name} is ready! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Invalid email or password. Please check your details.",
        "no_access": "Your access to the system is denied. Contact the administration.",
        "server_error": "A server error occurred. Please try again."
      }
    },
    "destinations": {
      "object_added": "Object successfully added",
      "object_edited": "Object successfully edited"
    },
    "employees": {
      "employee_added": "Employee successfully added",
      "employee_added_with_invite": "Employee added and password setup email sent",
      "employee_edited": "Employee data successfully updated",
      "password_email_failed": "Employee added, but sending the password setup email failed."
    },
    "explosives": {
      "all_items_moved": "All selected items successfully moved",
      "all_items_removed": "All units successfully removed",
      "all_items_returned": "All units successfully returned to storage",
      "database_updated": "Database updated",
      "failed_import_file_count": "%{count_failed} out of %{count_total} failed to import",
      "failed_to_add": "%{count} units failed to be added",
      "failed_to_import": "Failed to import file %{filename} because %{reason}",
      "import_in_progress": "Import in progress. You will be notified of the result.",
      "item_already_at_destination": "already at destination",
      "item_not_found": "not found",
      "item_removed": "removed",
      "item_unavailable": "unavailable",
      "multiple_warehouses": "Error! Scanned units are located in multiple warehouses, please clarify their numbers.",
      "no_files_selected": "No files selected",
      "no_item_settings": "Some units are not linked to settings",
      "no_items_found": "No items were found in the given number range",
      "no_warehouse": "--",
      "not_all_items_moved": "An error occurred while moving units; please check the item list.",
      "not_all_states_changed": "An error occurred, and some unit statuses did not change",
      "not_available_for_movement": "Explosive item is not available",
      "partial_items_moved": "Successfully moved %{moved} selected items. %{failed} selected items failed (e.g. %{examples}).",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "range_too_large": "Range is too large (max %{max} items)",
      "warehouse_not_selected": "No destination warehouse selected"
    },
    "item_settings": {
      "created": "Unit settings successfully created",
      "deleted": "Unit settings successfully deleted",
      "edited": "Unit settings successfully updated",
      "failed_to_create": "Error creating unit settings",
      "failed_to_edit": "Error updating unit settings",
      "unable_to_delete": "Cannot delete because it is linked to explosives"
    },
    "reports": {
      "error": "An error occurred. Please try to generate the report again!",
      "no_period": "Specify the explosives movement report period!",
      "no_report": "Report file not found!",
      "preparation_error": "An error occurred while preparing report %{report_name}"
    },
    "sessions": {
      "invalid_credentials": "Invalid email or password. Please check your details.",
      "no_access": "Your access to the system is denied. Contact the administration.",
      "server_error": "A server error occurred. Please try again."
    },
    "takeout_waybills": {
      "data_updated": "Waybill data updated",
      "waybill_edited": "Waybill already edited"
    },
    "takeouts": {
      "add_back_to_warehouse": "Place the units back in the correct warehouse!",
      "item_not_removed": "Error, failed to remove unit",
      "item_removed": "Unit successfully removed",
      "need_more_data": "Please specify waybill details",
      "no_access": "You do not have access rights",
      "no_access_system_error": "A system error occurred related to your access authorization",
      "scan_to_next_object_title": "Scan units to take to %{destination}",
      "takeout_confirmation_modal_title": "Are you sure you want to go to %{destination} with the units:",
      "takeout_exists": "Error! Such a takeout already exists!",
      "takeout_unavailable": "Takeout unavailable",
      "to_next_object_button": "Move to %{destination}"
    },
    "vehicles": {
      "created": "Vehicle successfully added",
      "edited": "Vehicle successfully edited"
    },
    "warehouses": {
      "unable_to_delete": "Failed to delete the warehouse",
      "warehouse_created": "Warehouse successfully created",
      "warehouse_deleted": "Warehouse successfully deleted",
      "warehouse_edited": "Warehouse data successfully updated"
    }
  },
  "create": "Create",
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "delete": "Delete",
  "destinations": {
    "edit": {
      "title": "Edit Site"
    },
    "form": {
      "adress_note": "The address must be unique.",
      "adress_placeholder": "Site address",
      "name_placeholder": "Site name"
    },
    "new": {
      "title": "Add New Site"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Your email address has been successfully confirmed.",
      "new": {
        "resend_confirmation_instructions": "Resend confirmation instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
    },
    "failure": {
      "already_authenticated": "You are already signed in.",
      "inactive": "Your account is not activated yet.",
      "invalid": "Invalid %{authentication_keys} or password.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Your account is locked.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Your session expired. Please sign in again to continue.",
      "unauthenticated": "You need to sign in or sign up before continuing.",
      "unconfirmed": "You have to confirm your email address before continuing."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Confirm my account",
        "greeting": "Welcome %{recipient}!",
        "instruction": "You can confirm your account email through the link below:",
        "subject": "Confirmation instructions"
      },
      "email_changed": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your email has been changed to %{email}.",
        "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
        "subject": "Email Changed"
      },
      "password_change": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your password has been changed.",
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "action": "Change my password",
        "greeting": "Hello %{recipient}!",
        "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
        "instruction_2": "If you didn't request this, please ignore this email.",
        "instruction_3": "Your password won't change until you access the link above and create a new one.",
        "subject": "Reset password instructions"
      },
      "unlock_instructions": {
        "action": "Unlock my account",
        "greeting": "Hello %{recipient}!",
        "instruction": "Click the link below to unlock your account:",
        "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
        "subject": "Unlock instructions"
      }
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "change_my_password": "Change my password",
        "change_your_password": "Change your password",
        "confirm_new_password": "Confirm new password",
        "new_password": "New password"
      },
      "new": {
        "forgot_your_password": "Forgot your password?",
        "send_me_reset_password_instructions": "Send me reset password instructions"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Your password has been changed successfully. You are now signed in.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
      "edit": {
        "are_you_sure": "Are you sure?",
        "cancel_my_account": "Cancel my account",
        "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
        "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
        "title": "Edit %{resource}",
        "unhappy": "Unhappy?",
        "update": "Update",
        "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
      },
      "new": {
        "sign_up": "Sign up"
      },
      "signed_up": "Welcome! You have signed up successfully.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Your account has been updated successfully.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "sign_in": "Log in"
      },
      "signed_in": "Signed in successfully.",
      "signed_out": "Signed out successfully."
    },
    "shared": {
      "links": {
        "back": "Back",
        "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
        "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
        "forgot_your_password": "Forgot your password?",
        "sign_in": "Log in",
        "sign_in_with_provider": "Sign in with %{provider}",
        "sign_up": "Sign up"
      },
      "minimum_password_length": {
        "one": "(%{count} character minimum)",
        "other": "(%{count} characters minimum)"
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": "Resend unlock instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
    }
  },
  "download": "Download",
  "edit": "Edit",
  "edit_object": "Edit",
  "employees": {
    "edit": {
      "title": "Edit Employee"
    },
    "form": {
      "email_note": "Must be a @gmail.com or @balrock.lv email.",
      "email_placeholder": "Enter the employee’s email",
      "first_name_note": "The first name cannot contain digits.",
      "first_name_placeholder": "Enter the employee’s first name",
      "last_name_note": "The last name cannot contain digits.",
      "last_name_placeholder": "Enter the employee’s last name"
    },
    "index": {
      "employee_enabled": "System access",
      "subtitle": "Employee and access management",
      "title": "Employees"
    },
    "new": {
      "title": "Add New Employee"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "was already confirmed, please try signing in",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "has expired, please request a new one",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "not found",
      "not_locked": "was not locked",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    }
  },
  "explosive_unit": "Unit",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "subtitle": "Scan a code or enter a number and choose the next action",
      "title": "Explosive Quantity Correction"
    },
    "index": {
      "title": "Erroneous Records"
    },
    "location": {
      "removed": "-- (Manually Deleted)",
      "used": "Used - %{destination_name}",
      "warehouse": "Warehouse"
    },
    "new": {
      "drop_files": "Drop files here",
      "import": "Import",
      "upload_note": "Choose one or more .xml or .xlsx files."
    },
    "warehouse_movement": {
      "entry_mode_label": "Entry mode",
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "process_range": "Process Range",
      "range_end": "Range End",
      "range_end_placeholder": "e.g. 275998",
      "range_entry": "Range Entry",
      "range_entry_title": "Range entry:",
      "range_start": "Range Start",
      "range_start_placeholder": "e.g. 275961",
      "single_entry": "Single Entry",
      "subtitle": "Choose the destination warehouse, then scan a code or enter a number",
      "title": "Move Explosives Between Warehouses",
      "warehouse_select_label": "Destination warehouse",
      "warehouse_select_placeholder": "Choose a warehouse"
    }
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e6177b8 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/common_pluralizations/one_other.rb:7 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Item weight and waybill settings",
      "title": "Item Settings"
    },
    "item_setting_row": {
      "weight_note": "Default weight"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Error!"
    },
    "correction_code_scanner": {
      "camera_alert": "Camera unavailable!",
      "correction_modal_title": "Quantity Correction",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "no_camera_permission": "You may not have granted permission or JavaScript is disabled.",
      "remove_explosives": "Delete from warehouse",
      "revive_explosives": "Return to inventory (no warehouse)",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "which_has": ", which has "
    },
    "file_upload": {
      "files_selected": " files selected",
      "import_notification": "Data is being imported, please wait."
    },
    "item_settings": {
      "success": "Success"
    },
    "loading_screen": {
      "please_wait": "Please wait..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Add selected items",
      "already_scanned": "Code already scanned",
      "camera_off": "Camera off!",
      "confirm_scanned_items": "I confirm that the scanned items and their statuses are correct",
      "confirm_used_items": "I confirm that all taken-out items were used on site",
      "error_occurred": "An error occurred",
      "failed_to_remove_item": "Error removing item. Try again or contact the administrator!",
      "item_already_scanned": "Item(s) already scanned.",
      "item_returnable": "Returnable",
      "item_used": "Used",
      "items_return_confirmation": "Do you want to return the following items?",
      "items_take_confirmation": "Do you want to take out the following items?",
      "no_items_scanned": "No items scanned",
      "range_modal_title": "Add items from range",
      "refresh_for_camera": "To turn the camera back on, please refresh the page!",
      "return_scanned": "The scanned items will be considered returned to the warehouse.",
      "scan_returnable_items": "Scanning returned items",
      "scan_used_items": "Used item scanning mode",
      "writeoff_scanned": "The scanned items will be considered used at the site. !! All taken-out items in the same package as the scanned item will be returned !!"
    },
    "warehouse_movement": {
      "confirm_move": "Confirm Move",
      "current_warehouse_name": "Warehouse",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "from_warehouse": "From %{warehouse}",
      "included_ids": "Included IDs (%{included} / %{total})",
      "items_badge": "%{count} Items",
      "modal_title": "Move Explosives Between Warehouses",
      "modal_title_short": "Move Explosives",
      "move_error": "An error occurred while moving items; please check the item list.",
      "move_success": "Explosives moved successfully",
      "move_to_button": "Move",
      "move_warehouse_info": "Move from #{from} to #{to}",
      "no_items_found": "No items were found in the given number range",
      "no_items_selected": "Select at least one item to move",
      "range_failures_preview": "%{count} items cannot be moved (e.g. %{examples}).",
      "range_label": "Range: %{start} → %{end}",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "subtitle_range": "Choose the destination warehouse, then enter or scan a number range",
      "to_warehouse": "To %{warehouse}",
      "total_items": "%{count} Items",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "No destination warehouse selected",
      "which_has": ", which has "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Got it",
      "confirmation": "Please confirm.",
      "title": "Error!"
    },
    "application": {
      "title": "Balrock Warehouse Management"
    },
    "camera_switch": {
      "use_camera": "Use Camera"
    },
    "confirmation_modal": {
      "confirm": "Confirm",
      "confirmation": "Have you used all the taken-out items?",
      "title": "Confirmation"
    },
    "delete_modal": {
      "confirmation": "Are you sure you want to delete %{deletable_object}?",
      "title": "Delete Confirmation"
    },
    "external_scanner": {
      "item_number_placeholder": "Manual number entry",
      "search": "Search",
      "title": "Manual entry or external scanner:"
    },
    "loading_overlay": {
      "please_wait": "Please wait..."
    },
    "sidebar": {
      "additional_code_printouts": "Additional Code Printing",
      "back": "Back",
      "correction": "Amount Correction",
      "home": "Home",
      "language": "Language",
      "logout": "Log Out",
      "logs": "Event List",
      "menu": "Menu",
      "receive_explosives": "Receive",
      "reports": "Reports",
      "return": "Return",
      "settings": {
        "destinations": "Sites",
        "employees": "Employees",
        "item_settings": "Item Settings",
        "title": "Settings",
        "vehicles": "Vehicles"
      },
      "takeout": "Take Out",
      "title": "Balrock Explosives Warehouse",
      "warehouse_movement": "Warehouse Movement",
      "warehouses": "Warehouses",
      "waybills": "Waybills"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Consolidated report (all warehouses)",
      "description": "Please select which warehouses to include in the report:",
      "prepare_report": "Prepare Report",
      "title": "Select Warehouses"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Number of corrected items:",
      "corrected_explosives_table": "Corrected Explosives",
      "correction_action": "Correction action:",
      "correction_date": "Date:",
      "deletion": "❌ Deletion",
      "employee": "Correction performed by:",
      "return": "✅ Returned to warehouse",
      "title": "Explosive Corrections Report"
    },
    "helper_row": {
      "changes": "Changes",
      "corrected_explosives_count": "Number of corrected explosives",
      "correction_action": "Correction action",
      "deletion": "Deletion",
      "edited": "Edited",
      "edited_object": "Edited item",
      "error": "Something went wrong",
      "imported_explosives_count": "Number of added explosives",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "movement_route": "Movement route",
      "precise_time": "Precise time",
      "return": "Return to warehouse",
      "returned_explosives_count": "Number of returned explosives",
      "taken_explosives_count": "Number of taken-out explosives",
      "takeout_responsible_employee": "Person responsible for takeout (creator)",
      "to_overview": "To overview",
      "used_explosives_count": "Used explosives count",
      "used_explosives_weight": "Used explosives weight"
    },
    "index": {
      "filtering": "Filtering",
      "subtitle": "Events are sorted in descending order by date",
      "title": "Activity Log"
    },
    "log_querry": {
      "clear_filters": "Clear Filters",
      "filter": "Filter"
    },
    "log_table": {
      "no_results": "Nothing found matching the given criteria"
    },
    "warehouse_moved_explosives": {
      "employee": "Moved by:",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "moved_explosives_table": "Moved explosives",
      "movement_date": "Date:",
      "title": "Explosives moved between warehouses"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Active explosives takeouts:",
      "current_employee": "User:",
      "employee_admin": "Administrator",
      "employee_regular": "Employee",
      "employee_role": "Status:",
      "explosives_in_warehouse": "Number of explosives in warehouse:",
      "no_actions": "You have not performed any actions yet.",
      "previous_actions": "Your latest actions:",
      "title": "Balrock Explosives Warehouse Management"
    }
  },
  "new_object": "Add",
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Billion",
            "other": "Billion"
          },
          "million": {
            "one": "Million",
            "other": "Million"
          },
          "quadrillion": {
            "one": "Quadrillion",
            "other": "Quadrillion"
          },
          "thousand": {
            "one": "Thousand",
            "other": "Thousand"
          },
          "trillion": {
            "one": "Trillion",
            "other": "Trillion"
          },
          "unit": {
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x00007fc57e632c70 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x00007fc57e632c98 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Page %{page_input} of %{pages}",
    "info": {
      "multiple_pages": "Displaying %{item_name} <b>%{from}-%{to}</b> of <b>%{count}</b> in total",
      "no_items": "No %{item_name} found",
      "single_page": "Displaying <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Record",
      "other": "Records"
    },
    "items_selector_js": "Include %{items_input} %{item_name} records on the page",
    "nav": {
      "gap": "&hellip;",
      "next": "Next&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Previous"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Failed to create printable codes",
      "invalid_code_type": "Invalid item code type"
    },
    "index": {
      "no_results": "Nothing found",
      "package_search": "Search for boxes of items to print by name",
      "package_search_placeholder": "Name or part of it",
      "search": "Search",
      "title": "Duplicate Item Code Printing"
    },
    "table_row": {
      "get_pdf": "Get PDF code sheet"
    }
  },
  "remove": "Remove",
  "reports": {
    "index": {
      "available_explosives_count": "Currently, %{count} items are available",
      "available_explosives_report": "Available Explosives",
      "date_range": "Time Period",
      "explosive_movement_report": "Explosive Movement within a Time Period",
      "explosive_summary": "Explosive Stock in Warehouse by Name",
      "explosives_in_warehouse": "Currently in the warehouse:",
      "prepare_report": "Prepare",
      "tab_all": "All",
      "tab_without_warehouse": "Without warehouse",
      "title": "Available System Reports (.xlsx)"
    },
    "quick_report_tab": {
      "total_amount": "Total:",
      "units": "Units",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Location",
              "Responsible"
            ],
            "no_employee": "No responsible person assigned",
            "report_row_title": "Overview of Available Explosives %{date}",
            "report_warehouse_row_title": "Overview of Available Explosives in Warehouse %{warehouse} - %{date}",
            "warehouse_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Responsible"
            ],
            "worksheet_title": "Available Explosives"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "ActiveTakeout-%{index}-%{date}",
              "returned": "ReturnedTakeout-%{index}-%{date}"
            },
            "states": {
              "active": "taken out",
              "returned": "returned",
              "used": "used"
            },
            "takeout_explosives_headers": [
              "Code",
              "Name",
              "Box",
              "Package",
              "Explosive",
              "Import File",
              "Status"
            ],
            "takeout_info_headers": [
              "Employee",
              "Work Site",
              "Vehicle",
              "Status",
              "Number of Taken-Out Items",
              "Number of Used Items"
            ],
            "worksheet_title": "Explosives Takeout/Return Report"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Driver",
    "employee": "Employee",
    "manager": "Manager"
  },
  "save": "Save",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "All units successfully written off!",
        "failed_to_return": "{count} units could not be returned.",
        "returned": "Units successfully returned!",
        "server_error": "Server error returning units!"
      },
      "take_explosives": {
        "failed_to_take": "{count} units could not be taken.",
        "server_error": "Server error taking units!",
        "success": "Units successfully taken"
      },
      "type": "Explosive"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Add to warehouse",
      "expand": "Expand",
      "title": "Explosives without warehouse"
    }
  },
  "state": "Enabled",
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Waybill FROM",
    "button_title_to": "Waybill TO",
    "custom_item_form_row": {
      "not_included_in_waybill": "This item is not included in the waybill"
    },
    "edit": {
      "manual_items": "Manually Enterable Items",
      "title": "Editing Waybill %{number}",
      "view_waybill": "View Waybill",
      "waybill_persons": "Waybill Persons"
    },
    "index": {
      "subtitle": "List of all created waybills",
      "title": "Waybills"
    },
    "pdf": {
      "default_packaging_type": "cardboard box",
      "failed_to_create": "Failed to create waybill",
      "header": {
        "date": "Date",
        "route": "Route",
        "waybill": "Waybill",
        "waybill_nr": "WAYBILL No."
      },
      "item_counts": {
        "kogus": "Quantity",
        "laohoidja": "Warehouse keeper:",
        "seeria_nr": "Taken:",
        "tagastus": "Return:",
        "vedaja_lohkaja": "Carrier/Blaster/Blast master:",
        "veokiri_nr": "WAYBILL nr:"
      },
      "legal_entity": {
        "address": "Address",
        "reg_number": "Reg. No.",
        "title": "Legal Entity",
        "vat_number": "VAT Reg. No."
      },
      "no_custom_item_data": "Failed to create waybill because all items in it do not have a specified weight",
      "sender_receiver": "Sender/Receiver:",
      "signatures": {
        "carrier_received": "Substance received by carrier:",
        "carrier_returned": "Substance remainder returned by carrier to warehouse keeper:",
        "carrier_title": "Carrier:",
        "date": "Date:",
        "issuer_title": "Persons responsible for goods issuance:",
        "miner_received": "Substance received from carrier by miner:",
        "miner_returned": "Substance remainder returned by miner to carrier:",
        "name": "Name, Surname:",
        "name_signature_date": "name, signature, date",
        "receiver_title": "Persons responsible for goods receipt:",
        "responsible_title": "Responsible person:",
        "signature": "Signature:",
        "warehouse_keeper_issued": "Waybill prepared and substance issued by warehouse keeper",
        "warehouse_keeper_received": "Substance remainder received by warehouse keeper:"
      },
      "table": {
        "aine_code": "Substance code",
        "consumption": "Consumption\nkg/pcs/m",
        "description": "Description",
        "name": "Name",
        "package_count": "Package count (pcs.)",
        "packaging": "Packaging",
        "quantity": "Quantity (pcs.)",
        "remainder": "Remainder\nkg/pcs/m",
        "source_warehouse": "Warehouse",
        "substance_code": "Substance code",
        "substance_name_description": "Substance name and description",
        "taken": "Taken\nkg/pcs/m",
        "total": "Total:",
        "total_weight": "Total weight (kg):",
        "uro_number": "URO No.",
        "weight_kg": "Weight (kg)"
      },
      "total_cargo": "Total cargo:",
      "transport": {
        "self_transport": "self-transport",
        "type": "Transport type",
        "vehicle_reg": "Vehicle Reg. No."
      },
      "units": {
        "kg": "kg",
        "pcs": "pcs"
      }
    },
    "table_row": {
      "to_destination": "To destination",
      "to_warehouse": "To warehouse"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "pcs."
    },
    "index": {
      "active_title": "Active takeouts (in progress)",
      "cta": "Click on one or create a new one!",
      "historical_title": "Completed takeouts (last 50)",
      "new_takeout": "New Takeout",
      "no_active_takeouts": "There are no active takeouts.",
      "no_historical_takeouts": "No completed takeouts yet.",
      "no_takeouts": "There are no takeouts yet.",
      "type": "Takeout"
    },
    "new": {
      "add_destination": "Add",
      "choose_destination": "Choose work site",
      "choose_vehicle": "Choose vehicle",
      "destinations": "Work sites",
      "drag_to_reorder": "Drag to reorder",
      "mandatory_field": "This field is required"
    },
    "returns": {
      "p_text": "Click on the relevant takeout to perform the return",
      "return": "Return"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Available units:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Remaining units:",
      "title": "Discard All remaining Explosives"
    },
    "scan_takeout_explosives": {
      "title": "Take Out Selected Explosives"
    },
    "scanner": {
      "delete_takeout": "Delete takeout",
      "destination": "Site: %{destination}",
      "item_count": "Number of items: %{count}",
      "no_camera_alert": "Camera unavailable",
      "no_camera_subalert": "You might not have granted permission to use the camera",
      "scan_only_used_explosives": "Select <strong>only</strong> items used on site",
      "scanned": "Scanned:",
      "this_takeout": "this takeout",
      "title": "Package Code Scanning",
      "vehicle": "Vehicle: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Active",
      "date": "Date:",
      "destination": "Work Site:",
      "employee": "Responsible for takeout:",
      "inactive_takeout": "❌ - Inactive/Returned",
      "state": "Status:",
      "subtitle": "*The table can be scrolled horizontally on narrow mobile devices",
      "title": "Explosives Takeout/Return Overview",
      "title_2": "Taken-Out Explosive Items",
      "title_3": "Used explosive items are highlighted in red",
      "vehicle": "Vehicle:"
    },
    "table": {
      "button_edit_return": "Edit",
      "button_return_to_warehouse": "Return to warehouse",
      "button_take_out": "Take Out",
      "button_to_next_object": "To next object",
      "items": "%{count} items",
      "title": "Explosives %{action}"
    },
    "taken_explosives": {
      "no_person": "No responsible person assigned",
      "person": "Taken out by: %{name}",
      "title": "Taken-Out Items:",
      "unknown": "unknown"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "vehicles": {
    "edit": {
      "title": "Edit Vehicle"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Important to keep the license plate format"
    },
    "index": {
      "delete_modal_text": "vehicle %{number_plate}",
      "subtitle": "Management of vehicles able to carry explosives",
      "title": "Vehicles"
    },
    "new": {
      "title": "Add New Vehicle"
    }
  },
  "view": "View",
  "warehouses": {
    "edit": {
      "title": "Editing %{warehouse_name}"
    },
    "form": {
      "country_code_hint": "Use the ISO 3166-1 alpha-2 code, e.g. LV.",
      "latitude_hint": "Use the latitude, e.g. 56.96130.",
      "longitude_hint": "Use the longitude, e.g. 24.12540.",
      "responsible_person_prompt": "Choose a responsible person"
    },
    "index": {
      "subtitle": "Warehouse list and management",
      "title": "Warehouses"
    },
    "new": {
      "title": "Add New Warehouse"
    },
    "show": {
      "details_title": "Warehouse details",
      "explosives_title": "Explosives in warehouse",
      "map_title": "Location on map",
      "no_explosives": "No explosives are currently stored in this warehouse."
    }
  }
});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
  "actions": "Actions",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Address",
        "name": "Name"
      },
      "employee": {
        "active": "Active",
        "admin": "Super-rights",
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "role": "Role"
      },
      "explosive": {
        "available": "Available",
        "box_number": "Box Number",
        "code": "Item Code",
        "delivery_date": "Delivery Date",
        "grouped_number": "Grouped number",
        "import_name": "Imported File Name",
        "item_number": "Item Number",
        "location": "Location",
        "manufacturer": "Manufacturer",
        "middlebox_number": "Package Number",
        "number_type": "Number type",
        "product_name": "Product Name",
        "product_number": "Product Number",
        "reason": "Reason",
        "takeout": "Takeout",
        "unknown_type": "Unknown type"
      },
      "item_setting": {
        "aine_code": "Substance Code",
        "countable_unit": "Countable Unit",
        "countable_units": {
          "units": "Units",
          "weight": "Weight"
        },
        "include_in_waybills": "Include in Waybills",
        "item_count": "Number of Items",
        "item_name_display": "Display Name",
        "item_name_import": "Item Name",
        "manually_created": "Manually Created",
        "set_weight_manually": "Manual Weight",
        "uro_number": "URO Number",
        "waybill_position": "Waybill Position",
        "weight": "Weight"
      },
      "log": {
        "action": "Action",
        "actions": {
          "atgriešana": "Return",
          "dzēšana": "Deletion",
          "izņemšana": "Takeout",
          "korekcija": "Correction",
          "noliktavas pārvietošana": "Warehouse transfer",
          "pievienošana": "Addition",
          "rediģēšana": "Editing",
          "saņemšana": "Data import",
          "starp-objektu pārvietošana": "Inter-object transfer"
        },
        "author": "Performed By",
        "corrected_explosives": "Corrected Explosives",
        "current_destination": "Current Location",
        "date": "Date",
        "destination": "Work Site",
        "destinations": "Work Sites",
        "employee": "Employee",
        "id_number": "ID Number",
        "import_name": "Import File",
        "notes": "Notes",
        "takeout": "Takeout",
        "takeout_waybill": "Takeout Waybill",
        "takeout_waybill_custom_items": "Manual Row in the Takeout Waybill",
        "vehicle": "Vehicle"
      },
      "pdf_code_printout": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "report": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "takeout": {
        "active": "Active?",
        "date": "Date",
        "destination": "Work Site",
        "employee": "Creator",
        "removed": "Removed",
        "vehicle": "Vehicle",
        "waybills": "Waybills"
      },
      "takeout_waybill": {
        "date": "Date",
        "destination": "Site",
        "direction": "Direction",
        "employee": "Employee",
        "initally_edited": "Edited",
        "issuance_person": "Issuance Person",
        "issuer": "Sender",
        "legal_entity": "Legal Entity",
        "number": "Number",
        "receiver": "Receiver",
        "receiving_person": "Receiving Person",
        "route": "Route",
        "scope": "Waybill scope",
        "takeout": "Takeout",
        "to_object": "To Site",
        "vehicle": "Vehicle"
      },
      "takeout_waybill_custom_item": {
        "amount": "Quantity",
        "item_setting": "Item Settings",
        "name": "Name",
        "package_name": "Package",
        "takeout_waybill": "Takeout Waybill",
        "weight": "Weight"
      },
      "user": {
        "confirmation_sent_at": "Confirmation sent at",
        "confirmation_token": "Confirmation token",
        "confirmed_at": "Confirmed at",
        "created_at": "Created at",
        "current_password": "Current password",
        "current_sign_in_at": "Current sign in at",
        "current_sign_in_ip": "Current sign in IP",
        "email": "Email",
        "encrypted_password": "Encrypted password",
        "failed_attempts": "Failed attempts",
        "last_sign_in_at": "Last sign in at",
        "last_sign_in_ip": "Last sign in IP",
        "locked_at": "Locked at",
        "password": "Password",
        "password_confirmation": "Password confirmation",
        "remember_created_at": "Remember created at",
        "remember_me": "Remember me",
        "reset_password_sent_at": "Reset password sent at",
        "reset_password_token": "Reset password token",
        "sign_in_count": "Sign in count",
        "unconfirmed_email": "Unconfirmed email",
        "unlock_token": "Unlock token",
        "updated_at": "Updated at"
      },
      "vehicle": {
        "active": "Active",
        "number_plate": "License Plate"
      },
      "warehouse": {
        "address": "Address",
        "city": "City",
        "country_code": "Country Code",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "name": "Name",
        "responsible_employee": "Responsible Person",
        "zip": "Postal Code"
      }
    },
    "created_at": "Created",
    "errors": {
      "destination": {
        "adress_taken": "Address has already been taken",
        "generic_error": "Error in input data",
        "name_blank": "Name can't be blank"
      },
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Employee already has identical takeout",
        "missing_destinations": "Must have at least one destination"
      },
      "takeout_waybill": {
        "destination_unknown": "Unknown"
      }
    },
    "models": {
      "destination": "Work Site",
      "employee": "Employee",
      "explosive": "Explosive",
      "item_setting": "Item Setting",
      "log": "Activity Log",
      "pdf_code_printout": "PDF Code Printout",
      "report": "Report",
      "takeout": "Explosives Takeout",
      "takeout_waybill": "Waybill",
      "takeout_waybill_custom_item": "Manually Entered Item",
      "user": {
        "one": "User",
        "other": "Users"
      },
      "vehicle": "Vehicle",
      "warehouse": "Warehouse"
    },
    "removed": "Removed",
    "updated_at": "Updated"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Back to login",
        "description": "Choose a new password for your account.",
        "password_confirmation_label": "Confirm new password",
        "password_label": "New password",
        "submit": "Update password",
        "title": "Set your password"
      },
      "new": {
        "back_to_login": "Back to login",
        "description": "Enter your work email to receive a password setup link.",
        "submit": "Send link",
        "title": "Request password link"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "or",
        "email_login_button": "Email login",
        "email_login_title": "Email login with your work email",
        "google_auth": "Log In with Google",
        "password_label": "Password",
        "password_link_text": "Request password link",
        "remember_me": "Remember me",
        "title": "Log In to BALROCK Warehouse Management"
      }
    }
  },
  "back": "Back",
  "cancel": "Cancel",
  "controllers": {
    "application": {
      "not_logged_in": "You must log in to view the requested page!",
      "not_permitted": "You do not have permission to view the requested page!",
      "report_ready": "Your report: %{report_name} is ready! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Invalid email or password. Please check your details.",
        "no_access": "Your access to the system is denied. Contact the administration.",
        "server_error": "A server error occurred. Please try again."
      }
    },
    "destinations": {
      "object_added": "Object successfully added",
      "object_edited": "Object successfully edited"
    },
    "employees": {
      "employee_added": "Employee successfully added",
      "employee_added_with_invite": "Employee added and password setup email sent",
      "employee_edited": "Employee data successfully updated",
      "password_email_failed": "Employee added, but sending the password setup email failed."
    },
    "explosives": {
      "all_items_moved": "All selected items successfully moved",
      "all_items_removed": "All units successfully removed",
      "all_items_returned": "All units successfully returned to storage",
      "database_updated": "Database updated",
      "failed_import_file_count": "%{count_failed} out of %{count_total} failed to import",
      "failed_to_add": "%{count} units failed to be added",
      "failed_to_import": "Failed to import file %{filename} because %{reason}",
      "import_in_progress": "Import in progress. You will be notified of the result.",
      "item_already_at_destination": "already at destination",
      "item_not_found": "not found",
      "item_removed": "removed",
      "item_unavailable": "unavailable",
      "multiple_warehouses": "Error! Scanned units are located in multiple warehouses, please clarify their numbers.",
      "no_files_selected": "No files selected",
      "no_item_settings": "Some units are not linked to settings",
      "no_items_found": "No items were found in the given number range",
      "no_warehouse": "--",
      "not_all_items_moved": "An error occurred while moving units; please check the item list.",
      "not_all_states_changed": "An error occurred, and some unit statuses did not change",
      "not_available_for_movement": "Explosive item is not available",
      "partial_items_moved": "Successfully moved %{moved} selected items. %{failed} selected items failed (e.g. %{examples}).",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "range_too_large": "Range is too large (max %{max} items)",
      "warehouse_not_selected": "No destination warehouse selected"
    },
    "item_settings": {
      "created": "Unit settings successfully created",
      "deleted": "Unit settings successfully deleted",
      "edited": "Unit settings successfully updated",
      "failed_to_create": "Error creating unit settings",
      "failed_to_edit": "Error updating unit settings",
      "unable_to_delete": "Cannot delete because it is linked to explosives"
    },
    "reports": {
      "error": "An error occurred. Please try to generate the report again!",
      "no_period": "Specify the explosives movement report period!",
      "no_report": "Report file not found!",
      "preparation_error": "An error occurred while preparing report %{report_name}"
    },
    "sessions": {
      "invalid_credentials": "Invalid email or password. Please check your details.",
      "no_access": "Your access to the system is denied. Contact the administration.",
      "server_error": "A server error occurred. Please try again."
    },
    "takeout_waybills": {
      "data_updated": "Waybill data updated",
      "waybill_edited": "Waybill already edited"
    },
    "takeouts": {
      "add_back_to_warehouse": "Place the units back in the correct warehouse!",
      "item_not_removed": "Error, failed to remove unit",
      "item_removed": "Unit successfully removed",
      "need_more_data": "Please specify waybill details",
      "no_access": "You do not have access rights",
      "no_access_system_error": "A system error occurred related to your access authorization",
      "scan_to_next_object_title": "Scan units to take to %{destination}",
      "takeout_confirmation_modal_title": "Are you sure you want to go to %{destination} with the units:",
      "takeout_exists": "Error! Such a takeout already exists!",
      "takeout_unavailable": "Takeout unavailable",
      "to_next_object_button": "Move to %{destination}"
    },
    "vehicles": {
      "created": "Vehicle successfully added",
      "edited": "Vehicle successfully edited"
    },
    "warehouses": {
      "unable_to_delete": "Failed to delete the warehouse",
      "warehouse_created": "Warehouse successfully created",
      "warehouse_deleted": "Warehouse successfully deleted",
      "warehouse_edited": "Warehouse data successfully updated"
    }
  },
  "create": "Create",
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "delete": "Delete",
  "destinations": {
    "edit": {
      "title": "Edit Site"
    },
    "form": {
      "adress_note": "The address must be unique.",
      "adress_placeholder": "Site address",
      "name_placeholder": "Site name"
    },
    "new": {
      "title": "Add New Site"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Your email address has been successfully confirmed.",
      "new": {
        "resend_confirmation_instructions": "Resend confirmation instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
    },
    "failure": {
      "already_authenticated": "You are already signed in.",
      "inactive": "Your account is not activated yet.",
      "invalid": "Invalid %{authentication_keys} or password.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Your account is locked.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Your session expired. Please sign in again to continue.",
      "unauthenticated": "You need to sign in or sign up before continuing.",
      "unconfirmed": "You have to confirm your email address before continuing."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Confirm my account",
        "greeting": "Welcome %{recipient}!",
        "instruction": "You can confirm your account email through the link below:",
        "subject": "Confirmation instructions"
      },
      "email_changed": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your email has been changed to %{email}.",
        "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
        "subject": "Email Changed"
      },
      "password_change": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your password has been changed.",
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "action": "Change my password",
        "greeting": "Hello %{recipient}!",
        "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
        "instruction_2": "If you didn't request this, please ignore this email.",
        "instruction_3": "Your password won't change until you access the link above and create a new one.",
        "subject": "Reset password instructions"
      },
      "unlock_instructions": {
        "action": "Unlock my account",
        "greeting": "Hello %{recipient}!",
        "instruction": "Click the link below to unlock your account:",
        "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
        "subject": "Unlock instructions"
      }
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "change_my_password": "Change my password",
        "change_your_password": "Change your password",
        "confirm_new_password": "Confirm new password",
        "new_password": "New password"
      },
      "new": {
        "forgot_your_password": "Forgot your password?",
        "send_me_reset_password_instructions": "Send me reset password instructions"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Your password has been changed successfully. You are now signed in.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
      "edit": {
        "are_you_sure": "Are you sure?",
        "cancel_my_account": "Cancel my account",
        "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
        "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
        "title": "Edit %{resource}",
        "unhappy": "Unhappy?",
        "update": "Update",
        "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
      },
      "new": {
        "sign_up": "Sign up"
      },
      "signed_up": "Welcome! You have signed up successfully.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Your account has been updated successfully.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "sign_in": "Log in"
      },
      "signed_in": "Signed in successfully.",
      "signed_out": "Signed out successfully."
    },
    "shared": {
      "links": {
        "back": "Back",
        "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
        "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
        "forgot_your_password": "Forgot your password?",
        "sign_in": "Log in",
        "sign_in_with_provider": "Sign in with %{provider}",
        "sign_up": "Sign up"
      },
      "minimum_password_length": {
        "one": "(%{count} character minimum)",
        "other": "(%{count} characters minimum)"
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": "Resend unlock instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
    }
  },
  "download": "Download",
  "edit": "Edit",
  "edit_object": "Edit",
  "employees": {
    "edit": {
      "title": "Edit Employee"
    },
    "form": {
      "email_note": "Must be a @gmail.com or @balrock.lv email.",
      "email_placeholder": "Enter the employee’s email",
      "first_name_note": "The first name cannot contain digits.",
      "first_name_placeholder": "Enter the employee’s first name",
      "last_name_note": "The last name cannot contain digits.",
      "last_name_placeholder": "Enter the employee’s last name"
    },
    "index": {
      "employee_enabled": "System access",
      "subtitle": "Employee and access management",
      "title": "Employees"
    },
    "new": {
      "title": "Add New Employee"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "was already confirmed, please try signing in",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "has expired, please request a new one",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "not found",
      "not_locked": "was not locked",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    }
  },
  "explosive_unit": "Unit",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "subtitle": "Scan a code or enter a number and choose the next action",
      "title": "Explosive Quantity Correction"
    },
    "index": {
      "title": "Erroneous Records"
    },
    "location": {
      "removed": "-- (Manually Deleted)",
      "used": "Used - %{destination_name}",
      "warehouse": "Warehouse"
    },
    "new": {
      "drop_files": "Drop files here",
      "import": "Import",
      "upload_note": "Choose one or more .xml or .xlsx files."
    },
    "warehouse_movement": {
      "entry_mode_label": "Entry mode",
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "process_range": "Process Range",
      "range_end": "Range End",
      "range_end_placeholder": "e.g. 275998",
      "range_entry": "Range Entry",
      "range_entry_title": "Range entry:",
      "range_start": "Range Start",
      "range_start_placeholder": "e.g. 275961",
      "single_entry": "Single Entry",
      "subtitle": "Choose the destination warehouse, then scan a code or enter a number",
      "title": "Move Explosives Between Warehouses",
      "warehouse_select_label": "Destination warehouse",
      "warehouse_select_placeholder": "Choose a warehouse"
    }
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e6177b8 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/common_pluralizations/one_other.rb:7 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Item weight and waybill settings",
      "title": "Item Settings"
    },
    "item_setting_row": {
      "weight_note": "Default weight"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Error!"
    },
    "correction_code_scanner": {
      "camera_alert": "Camera unavailable!",
      "correction_modal_title": "Quantity Correction",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "no_camera_permission": "You may not have granted permission or JavaScript is disabled.",
      "remove_explosives": "Delete from warehouse",
      "revive_explosives": "Return to inventory (no warehouse)",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "which_has": ", which has "
    },
    "file_upload": {
      "files_selected": " files selected",
      "import_notification": "Data is being imported, please wait."
    },
    "item_settings": {
      "success": "Success"
    },
    "loading_screen": {
      "please_wait": "Please wait..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Add selected items",
      "already_scanned": "Code already scanned",
      "camera_off": "Camera off!",
      "confirm_scanned_items": "I confirm that the scanned items and their statuses are correct",
      "confirm_used_items": "I confirm that all taken-out items were used on site",
      "error_occurred": "An error occurred",
      "failed_to_remove_item": "Error removing item. Try again or contact the administrator!",
      "item_already_scanned": "Item(s) already scanned.",
      "item_returnable": "Returnable",
      "item_used": "Used",
      "items_return_confirmation": "Do you want to return the following items?",
      "items_take_confirmation": "Do you want to take out the following items?",
      "no_items_scanned": "No items scanned",
      "range_modal_title": "Add items from range",
      "refresh_for_camera": "To turn the camera back on, please refresh the page!",
      "return_scanned": "The scanned items will be considered returned to the warehouse.",
      "scan_returnable_items": "Scanning returned items",
      "scan_used_items": "Used item scanning mode",
      "writeoff_scanned": "The scanned items will be considered used at the site. !! All taken-out items in the same package as the scanned item will be returned !!"
    },
    "warehouse_movement": {
      "confirm_move": "Confirm Move",
      "current_warehouse_name": "Warehouse",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "from_warehouse": "From %{warehouse}",
      "included_ids": "Included IDs (%{included} / %{total})",
      "items_badge": "%{count} Items",
      "modal_title": "Move Explosives Between Warehouses",
      "modal_title_short": "Move Explosives",
      "move_error": "An error occurred while moving items; please check the item list.",
      "move_success": "Explosives moved successfully",
      "move_to_button": "Move",
      "move_warehouse_info": "Move from #{from} to #{to}",
      "no_items_found": "No items were found in the given number range",
      "no_items_selected": "Select at least one item to move",
      "range_failures_preview": "%{count} items cannot be moved (e.g. %{examples}).",
      "range_label": "Range: %{start} → %{end}",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "subtitle_range": "Choose the destination warehouse, then enter or scan a number range",
      "to_warehouse": "To %{warehouse}",
      "total_items": "%{count} Items",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "No destination warehouse selected",
      "which_has": ", which has "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Got it",
      "confirmation": "Please confirm.",
      "title": "Error!"
    },
    "application": {
      "title": "Balrock Warehouse Management"
    },
    "camera_switch": {
      "use_camera": "Use Camera"
    },
    "confirmation_modal": {
      "confirm": "Confirm",
      "confirmation": "Have you used all the taken-out items?",
      "title": "Confirmation"
    },
    "delete_modal": {
      "confirmation": "Are you sure you want to delete %{deletable_object}?",
      "title": "Delete Confirmation"
    },
    "external_scanner": {
      "item_number_placeholder": "Manual number entry",
      "search": "Search",
      "title": "Manual entry or external scanner:"
    },
    "loading_overlay": {
      "please_wait": "Please wait..."
    },
    "sidebar": {
      "additional_code_printouts": "Additional Code Printing",
      "back": "Back",
      "correction": "Amount Correction",
      "home": "Home",
      "language": "Language",
      "logout": "Log Out",
      "logs": "Event List",
      "menu": "Menu",
      "receive_explosives": "Receive",
      "reports": "Reports",
      "return": "Return",
      "settings": {
        "destinations": "Sites",
        "employees": "Employees",
        "item_settings": "Item Settings",
        "title": "Settings",
        "vehicles": "Vehicles"
      },
      "takeout": "Take Out",
      "title": "Balrock Explosives Warehouse",
      "warehouse_movement": "Warehouse Movement",
      "warehouses": "Warehouses",
      "waybills": "Waybills"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Consolidated report (all warehouses)",
      "description": "Please select which warehouses to include in the report:",
      "prepare_report": "Prepare Report",
      "title": "Select Warehouses"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Number of corrected items:",
      "corrected_explosives_table": "Corrected Explosives",
      "correction_action": "Correction action:",
      "correction_date": "Date:",
      "deletion": "❌ Deletion",
      "employee": "Correction performed by:",
      "return": "✅ Returned to warehouse",
      "title": "Explosive Corrections Report"
    },
    "helper_row": {
      "changes": "Changes",
      "corrected_explosives_count": "Number of corrected explosives",
      "correction_action": "Correction action",
      "deletion": "Deletion",
      "edited": "Edited",
      "edited_object": "Edited item",
      "error": "Something went wrong",
      "imported_explosives_count": "Number of added explosives",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "movement_route": "Movement route",
      "precise_time": "Precise time",
      "return": "Return to warehouse",
      "returned_explosives_count": "Number of returned explosives",
      "taken_explosives_count": "Number of taken-out explosives",
      "takeout_responsible_employee": "Person responsible for takeout (creator)",
      "to_overview": "To overview",
      "used_explosives_count": "Used explosives count",
      "used_explosives_weight": "Used explosives weight"
    },
    "index": {
      "filtering": "Filtering",
      "subtitle": "Events are sorted in descending order by date",
      "title": "Activity Log"
    },
    "log_querry": {
      "clear_filters": "Clear Filters",
      "filter": "Filter"
    },
    "log_table": {
      "no_results": "Nothing found matching the given criteria"
    },
    "warehouse_moved_explosives": {
      "employee": "Moved by:",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "moved_explosives_table": "Moved explosives",
      "movement_date": "Date:",
      "title": "Explosives moved between warehouses"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Active explosives takeouts:",
      "current_employee": "User:",
      "employee_admin": "Administrator",
      "employee_regular": "Employee",
      "employee_role": "Status:",
      "explosives_in_warehouse": "Number of explosives in warehouse:",
      "no_actions": "You have not performed any actions yet.",
      "previous_actions": "Your latest actions:",
      "title": "Balrock Explosives Warehouse Management"
    }
  },
  "new_object": "Add",
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Billion",
            "other": "Billion"
          },
          "million": {
            "one": "Million",
            "other": "Million"
          },
          "quadrillion": {
            "one": "Quadrillion",
            "other": "Quadrillion"
          },
          "thousand": {
            "one": "Thousand",
            "other": "Thousand"
          },
          "trillion": {
            "one": "Trillion",
            "other": "Trillion"
          },
          "unit": {
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x00007fc57e632c70 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x00007fc57e632c98 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Page %{page_input} of %{pages}",
    "info": {
      "multiple_pages": "Displaying %{item_name} <b>%{from}-%{to}</b> of <b>%{count}</b> in total",
      "no_items": "No %{item_name} found",
      "single_page": "Displaying <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Record",
      "other": "Records"
    },
    "items_selector_js": "Include %{items_input} %{item_name} records on the page",
    "nav": {
      "gap": "&hellip;",
      "next": "Next&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Previous"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Failed to create printable codes",
      "invalid_code_type": "Invalid item code type"
    },
    "index": {
      "no_results": "Nothing found",
      "package_search": "Search for boxes of items to print by name",
      "package_search_placeholder": "Name or part of it",
      "search": "Search",
      "title": "Duplicate Item Code Printing"
    },
    "table_row": {
      "get_pdf": "Get PDF code sheet"
    }
  },
  "remove": "Remove",
  "reports": {
    "index": {
      "available_explosives_count": "Currently, %{count} items are available",
      "available_explosives_report": "Available Explosives",
      "date_range": "Time Period",
      "explosive_movement_report": "Explosive Movement within a Time Period",
      "explosive_summary": "Explosive Stock in Warehouse by Name",
      "explosives_in_warehouse": "Currently in the warehouse:",
      "prepare_report": "Prepare",
      "tab_all": "All",
      "tab_without_warehouse": "Without warehouse",
      "title": "Available System Reports (.xlsx)"
    },
    "quick_report_tab": {
      "total_amount": "Total:",
      "units": "Units",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Location",
              "Responsible"
            ],
            "no_employee": "No responsible person assigned",
            "report_row_title": "Overview of Available Explosives %{date}",
            "report_warehouse_row_title": "Overview of Available Explosives in Warehouse %{warehouse} - %{date}",
            "warehouse_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Responsible"
            ],
            "worksheet_title": "Available Explosives"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "ActiveTakeout-%{index}-%{date}",
              "returned": "ReturnedTakeout-%{index}-%{date}"
            },
            "states": {
              "active": "taken out",
              "returned": "returned",
              "used": "used"
            },
            "takeout_explosives_headers": [
              "Code",
              "Name",
              "Box",
              "Package",
              "Explosive",
              "Import File",
              "Status"
            ],
            "takeout_info_headers": [
              "Employee",
              "Work Site",
              "Vehicle",
              "Status",
              "Number of Taken-Out Items",
              "Number of Used Items"
            ],
            "worksheet_title": "Explosives Takeout/Return Report"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Driver",
    "employee": "Employee",
    "manager": "Manager"
  },
  "save": "Save",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "All units successfully written off!",
        "failed_to_return": "{count} units could not be returned.",
        "returned": "Units successfully returned!",
        "server_error": "Server error returning units!"
      },
      "take_explosives": {
        "failed_to_take": "{count} units could not be taken.",
        "server_error": "Server error taking units!",
        "success": "Units successfully taken"
      },
      "type": "Explosive"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Add to warehouse",
      "expand": "Expand",
      "title": "Explosives without warehouse"
    }
  },
  "state": "Enabled",
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Waybill FROM",
    "button_title_to": "Waybill TO",
    "custom_item_form_row": {
      "not_included_in_waybill": "This item is not included in the waybill"
    },
    "edit": {
      "manual_items": "Manually Enterable Items",
      "title": "Editing Waybill %{number}",
      "view_waybill": "View Waybill",
      "waybill_persons": "Waybill Persons"
    },
    "index": {
      "subtitle": "List of all created waybills",
      "title": "Waybills"
    },
    "pdf": {
      "default_packaging_type": "cardboard box",
      "failed_to_create": "Failed to create waybill",
      "header": {
        "date": "Date",
        "route": "Route",
        "waybill": "Waybill",
        "waybill_nr": "WAYBILL No."
      },
      "item_counts": {
        "kogus": "Quantity",
        "laohoidja": "Warehouse keeper:",
        "seeria_nr": "Taken:",
        "tagastus": "Return:",
        "vedaja_lohkaja": "Carrier/Blaster/Blast master:",
        "veokiri_nr": "WAYBILL nr:"
      },
      "legal_entity": {
        "address": "Address",
        "reg_number": "Reg. No.",
        "title": "Legal Entity",
        "vat_number": "VAT Reg. No."
      },
      "no_custom_item_data": "Failed to create waybill because all items in it do not have a specified weight",
      "sender_receiver": "Sender/Receiver:",
      "signatures": {
        "carrier_received": "Substance received by carrier:",
        "carrier_returned": "Substance remainder returned by carrier to warehouse keeper:",
        "carrier_title": "Carrier:",
        "date": "Date:",
        "issuer_title": "Persons responsible for goods issuance:",
        "miner_received": "Substance received from carrier by miner:",
        "miner_returned": "Substance remainder returned by miner to carrier:",
        "name": "Name, Surname:",
        "name_signature_date": "name, signature, date",
        "receiver_title": "Persons responsible for goods receipt:",
        "responsible_title": "Responsible person:",
        "signature": "Signature:",
        "warehouse_keeper_issued": "Waybill prepared and substance issued by warehouse keeper",
        "warehouse_keeper_received": "Substance remainder received by warehouse keeper:"
      },
      "table": {
        "aine_code": "Substance code",
        "consumption": "Consumption\nkg/pcs/m",
        "description": "Description",
        "name": "Name",
        "package_count": "Package count (pcs.)",
        "packaging": "Packaging",
        "quantity": "Quantity (pcs.)",
        "remainder": "Remainder\nkg/pcs/m",
        "source_warehouse": "Warehouse",
        "substance_code": "Substance code",
        "substance_name_description": "Substance name and description",
        "taken": "Taken\nkg/pcs/m",
        "total": "Total:",
        "total_weight": "Total weight (kg):",
        "uro_number": "URO No.",
        "weight_kg": "Weight (kg)"
      },
      "total_cargo": "Total cargo:",
      "transport": {
        "self_transport": "self-transport",
        "type": "Transport type",
        "vehicle_reg": "Vehicle Reg. No."
      },
      "units": {
        "kg": "kg",
        "pcs": "pcs"
      }
    },
    "table_row": {
      "to_destination": "To destination",
      "to_warehouse": "To warehouse"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "pcs."
    },
    "index": {
      "active_title": "Active takeouts (in progress)",
      "cta": "Click on one or create a new one!",
      "historical_title": "Completed takeouts (last 50)",
      "new_takeout": "New Takeout",
      "no_active_takeouts": "There are no active takeouts.",
      "no_historical_takeouts": "No completed takeouts yet.",
      "no_takeouts": "There are no takeouts yet.",
      "type": "Takeout"
    },
    "new": {
      "add_destination": "Add",
      "choose_destination": "Choose work site",
      "choose_vehicle": "Choose vehicle",
      "destinations": "Work sites",
      "drag_to_reorder": "Drag to reorder",
      "mandatory_field": "This field is required"
    },
    "returns": {
      "p_text": "Click on the relevant takeout to perform the return",
      "return": "Return"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Available units:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Remaining units:",
      "title": "Discard All remaining Explosives"
    },
    "scan_takeout_explosives": {
      "title": "Take Out Selected Explosives"
    },
    "scanner": {
      "delete_takeout": "Delete takeout",
      "destination": "Site: %{destination}",
      "item_count": "Number of items: %{count}",
      "no_camera_alert": "Camera unavailable",
      "no_camera_subalert": "You might not have granted permission to use the camera",
      "scan_only_used_explosives": "Select <strong>only</strong> items used on site",
      "scanned": "Scanned:",
      "this_takeout": "this takeout",
      "title": "Package Code Scanning",
      "vehicle": "Vehicle: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Active",
      "date": "Date:",
      "destination": "Work Site:",
      "employee": "Responsible for takeout:",
      "inactive_takeout": "❌ - Inactive/Returned",
      "state": "Status:",
      "subtitle": "*The table can be scrolled horizontally on narrow mobile devices",
      "title": "Explosives Takeout/Return Overview",
      "title_2": "Taken-Out Explosive Items",
      "title_3": "Used explosive items are highlighted in red",
      "vehicle": "Vehicle:"
    },
    "table": {
      "button_edit_return": "Edit",
      "button_return_to_warehouse": "Return to warehouse",
      "button_take_out": "Take Out",
      "button_to_next_object": "To next object",
      "items": "%{count} items",
      "title": "Explosives %{action}"
    },
    "taken_explosives": {
      "no_person": "No responsible person assigned",
      "person": "Taken out by: %{name}",
      "title": "Taken-Out Items:",
      "unknown": "unknown"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "vehicles": {
    "edit": {
      "title": "Edit Vehicle"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Important to keep the license plate format"
    },
    "index": {
      "delete_modal_text": "vehicle %{number_plate}",
      "subtitle": "Management of vehicles able to carry explosives",
      "title": "Vehicles"
    },
    "new": {
      "title": "Add New Vehicle"
    }
  },
  "view": "View",
  "warehouses": {
    "edit": {
      "title": "Editing %{warehouse_name}"
    },
    "form": {
      "country_code_hint": "Use the ISO 3166-1 alpha-2 code, e.g. LV.",
      "latitude_hint": "Use the latitude, e.g. 56.96130.",
      "longitude_hint": "Use the longitude, e.g. 24.12540.",
      "responsible_person_prompt": "Choose a responsible person"
    },
    "index": {
      "subtitle": "Warehouse list and management",
      "title": "Warehouses"
    },
    "new": {
      "title": "Add New Warehouse"
    },
    "show": {
      "details_title": "Warehouse details",
      "explosives_title": "Explosives in warehouse",
      "map_title": "Location on map",
      "no_explosives": "No explosives are currently stored in this warehouse."
    }
  }
});
I18n.translations["lt"] = I18n.extend((I18n.translations["lt"] || {}), {
  "actions": "Actions",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Address",
        "name": "Name"
      },
      "employee": {
        "active": "Active",
        "admin": "Super-rights",
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "role": "Role"
      },
      "explosive": {
        "available": "Available",
        "box_number": "Box Number",
        "code": "Item Code",
        "delivery_date": "Delivery Date",
        "grouped_number": "Grouped number",
        "import_name": "Imported File Name",
        "item_number": "Item Number",
        "location": "Location",
        "manufacturer": "Manufacturer",
        "middlebox_number": "Package Number",
        "number_type": "Number type",
        "product_name": "Product Name",
        "product_number": "Product Number",
        "reason": "Reason",
        "takeout": "Takeout",
        "unknown_type": "Unknown type"
      },
      "item_setting": {
        "aine_code": "Substance Code",
        "countable_unit": "Countable Unit",
        "countable_units": {
          "units": "Units",
          "weight": "Weight"
        },
        "include_in_waybills": "Include in Waybills",
        "item_count": "Number of Items",
        "item_name_display": "Display Name",
        "item_name_import": "Item Name",
        "manually_created": "Manually Created",
        "set_weight_manually": "Manual Weight",
        "uro_number": "URO Number",
        "waybill_position": "Waybill Position",
        "weight": "Weight"
      },
      "log": {
        "action": "Action",
        "actions": {
          "atgriešana": "Return",
          "dzēšana": "Deletion",
          "izņemšana": "Takeout",
          "korekcija": "Correction",
          "noliktavas pārvietošana": "Warehouse transfer",
          "pievienošana": "Addition",
          "rediģēšana": "Editing",
          "saņemšana": "Data import",
          "starp-objektu pārvietošana": "Inter-object transfer"
        },
        "author": "Performed By",
        "corrected_explosives": "Corrected Explosives",
        "current_destination": "Current Location",
        "date": "Date",
        "destination": "Work Site",
        "destinations": "Work Sites",
        "employee": "Employee",
        "id_number": "ID Number",
        "import_name": "Import File",
        "notes": "Notes",
        "takeout": "Takeout",
        "takeout_waybill": "Takeout Waybill",
        "takeout_waybill_custom_items": "Manual Row in the Takeout Waybill",
        "vehicle": "Vehicle"
      },
      "pdf_code_printout": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "report": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "takeout": {
        "active": "Active?",
        "date": "Date",
        "destination": "Work Site",
        "employee": "Creator",
        "removed": "Removed",
        "vehicle": "Vehicle",
        "waybills": "Waybills"
      },
      "takeout_waybill": {
        "date": "Date",
        "destination": "Site",
        "direction": "Direction",
        "employee": "Employee",
        "initally_edited": "Edited",
        "issuance_person": "Issuance Person",
        "issuer": "Sender",
        "legal_entity": "Legal Entity",
        "number": "Number",
        "receiver": "Receiver",
        "receiving_person": "Receiving Person",
        "route": "Route",
        "scope": "Waybill scope",
        "takeout": "Takeout",
        "to_object": "To Site",
        "vehicle": "Vehicle"
      },
      "takeout_waybill_custom_item": {
        "amount": "Quantity",
        "item_setting": "Item Settings",
        "name": "Name",
        "package_name": "Package",
        "takeout_waybill": "Takeout Waybill",
        "weight": "Weight"
      },
      "user": {
        "confirmation_sent_at": "Confirmation sent at",
        "confirmation_token": "Confirmation token",
        "confirmed_at": "Confirmed at",
        "created_at": "Created at",
        "current_password": "Current password",
        "current_sign_in_at": "Current sign in at",
        "current_sign_in_ip": "Current sign in IP",
        "email": "Email",
        "encrypted_password": "Encrypted password",
        "failed_attempts": "Failed attempts",
        "last_sign_in_at": "Last sign in at",
        "last_sign_in_ip": "Last sign in IP",
        "locked_at": "Locked at",
        "password": "Password",
        "password_confirmation": "Password confirmation",
        "remember_created_at": "Remember created at",
        "remember_me": "Remember me",
        "reset_password_sent_at": "Reset password sent at",
        "reset_password_token": "Reset password token",
        "sign_in_count": "Sign in count",
        "unconfirmed_email": "Unconfirmed email",
        "unlock_token": "Unlock token",
        "updated_at": "Updated at"
      },
      "vehicle": {
        "active": "Active",
        "number_plate": "License Plate"
      },
      "warehouse": {
        "address": "Address",
        "city": "City",
        "country_code": "Country Code",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "name": "Name",
        "responsible_employee": "Responsible Person",
        "zip": "Postal Code"
      }
    },
    "created_at": "Created",
    "errors": {
      "destination": {
        "adress_taken": "Address has already been taken",
        "generic_error": "Error in input data",
        "name_blank": "Name can't be blank"
      },
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Employee already has identical takeout",
        "missing_destinations": "Must have at least one destination"
      },
      "takeout_waybill": {
        "destination_unknown": "Unknown"
      }
    },
    "models": {
      "destination": "Work Site",
      "employee": "Employee",
      "explosive": "Explosive",
      "item_setting": "Item Setting",
      "log": "Activity Log",
      "pdf_code_printout": "PDF Code Printout",
      "report": "Report",
      "takeout": "Explosives Takeout",
      "takeout_waybill": "Waybill",
      "takeout_waybill_custom_item": "Manually Entered Item",
      "user": {
        "one": "User",
        "other": "Users"
      },
      "vehicle": "Vehicle",
      "warehouse": "Warehouse"
    },
    "removed": "Removed",
    "updated_at": "Updated"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Back to login",
        "description": "Choose a new password for your account.",
        "password_confirmation_label": "Confirm new password",
        "password_label": "New password",
        "submit": "Update password",
        "title": "Set your password"
      },
      "new": {
        "back_to_login": "Back to login",
        "description": "Enter your work email to receive a password setup link.",
        "submit": "Send link",
        "title": "Request password link"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "or",
        "email_login_button": "Email login",
        "email_login_title": "Email login with your work email",
        "google_auth": "Log In with Google",
        "password_label": "Password",
        "password_link_text": "Request password link",
        "remember_me": "Remember me",
        "title": "Log In to BALROCK Warehouse Management"
      }
    }
  },
  "back": "Back",
  "cancel": "Cancel",
  "controllers": {
    "application": {
      "not_logged_in": "You must log in to view the requested page!",
      "not_permitted": "You do not have permission to view the requested page!",
      "report_ready": "Your report: %{report_name} is ready! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Invalid email or password. Please check your details.",
        "no_access": "Your access to the system is denied. Contact the administration.",
        "server_error": "A server error occurred. Please try again."
      }
    },
    "destinations": {
      "object_added": "Object successfully added",
      "object_edited": "Object successfully edited"
    },
    "employees": {
      "employee_added": "Employee successfully added",
      "employee_added_with_invite": "Employee added and password setup email sent",
      "employee_edited": "Employee data successfully updated",
      "password_email_failed": "Employee added, but sending the password setup email failed."
    },
    "explosives": {
      "all_items_moved": "All selected items successfully moved",
      "all_items_removed": "All units successfully removed",
      "all_items_returned": "All units successfully returned to storage",
      "database_updated": "Database updated",
      "failed_import_file_count": "%{count_failed} out of %{count_total} failed to import",
      "failed_to_add": "%{count} units failed to be added",
      "failed_to_import": "Failed to import file %{filename} because %{reason}",
      "import_in_progress": "Import in progress. You will be notified of the result.",
      "item_already_at_destination": "already at destination",
      "item_not_found": "not found",
      "item_removed": "removed",
      "item_unavailable": "unavailable",
      "multiple_warehouses": "Error! Scanned units are located in multiple warehouses, please clarify their numbers.",
      "no_files_selected": "No files selected",
      "no_item_settings": "Some units are not linked to settings",
      "no_items_found": "No items were found in the given number range",
      "no_warehouse": "--",
      "not_all_items_moved": "An error occurred while moving units; please check the item list.",
      "not_all_states_changed": "An error occurred, and some unit statuses did not change",
      "not_available_for_movement": "Explosive item is not available",
      "partial_items_moved": "Successfully moved %{moved} selected items. %{failed} selected items failed (e.g. %{examples}).",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "range_too_large": "Range is too large (max %{max} items)",
      "warehouse_not_selected": "No destination warehouse selected"
    },
    "item_settings": {
      "created": "Unit settings successfully created",
      "deleted": "Unit settings successfully deleted",
      "edited": "Unit settings successfully updated",
      "failed_to_create": "Error creating unit settings",
      "failed_to_edit": "Error updating unit settings",
      "unable_to_delete": "Cannot delete because it is linked to explosives"
    },
    "reports": {
      "error": "An error occurred. Please try to generate the report again!",
      "no_period": "Specify the explosives movement report period!",
      "no_report": "Report file not found!",
      "preparation_error": "An error occurred while preparing report %{report_name}"
    },
    "sessions": {
      "invalid_credentials": "Invalid email or password. Please check your details.",
      "no_access": "Your access to the system is denied. Contact the administration.",
      "server_error": "A server error occurred. Please try again."
    },
    "takeout_waybills": {
      "data_updated": "Waybill data updated",
      "waybill_edited": "Waybill already edited"
    },
    "takeouts": {
      "add_back_to_warehouse": "Place the units back in the correct warehouse!",
      "item_not_removed": "Error, failed to remove unit",
      "item_removed": "Unit successfully removed",
      "need_more_data": "Please specify waybill details",
      "no_access": "You do not have access rights",
      "no_access_system_error": "A system error occurred related to your access authorization",
      "scan_to_next_object_title": "Scan units to take to %{destination}",
      "takeout_confirmation_modal_title": "Are you sure you want to go to %{destination} with the units:",
      "takeout_exists": "Error! Such a takeout already exists!",
      "takeout_unavailable": "Takeout unavailable",
      "to_next_object_button": "Move to %{destination}"
    },
    "vehicles": {
      "created": "Vehicle successfully added",
      "edited": "Vehicle successfully edited"
    },
    "warehouses": {
      "unable_to_delete": "Failed to delete the warehouse",
      "warehouse_created": "Warehouse successfully created",
      "warehouse_deleted": "Warehouse successfully deleted",
      "warehouse_edited": "Warehouse data successfully updated"
    }
  },
  "create": "Create",
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "delete": "Delete",
  "destinations": {
    "edit": {
      "title": "Edit Site"
    },
    "form": {
      "adress_note": "The address must be unique.",
      "adress_placeholder": "Site address",
      "name_placeholder": "Site name"
    },
    "new": {
      "title": "Add New Site"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Your email address has been successfully confirmed.",
      "new": {
        "resend_confirmation_instructions": "Resend confirmation instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
    },
    "failure": {
      "already_authenticated": "You are already signed in.",
      "inactive": "Your account is not activated yet.",
      "invalid": "Invalid %{authentication_keys} or password.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Your account is locked.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Your session expired. Please sign in again to continue.",
      "unauthenticated": "You need to sign in or sign up before continuing.",
      "unconfirmed": "You have to confirm your email address before continuing."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Confirm my account",
        "greeting": "Welcome %{recipient}!",
        "instruction": "You can confirm your account email through the link below:",
        "subject": "Confirmation instructions"
      },
      "email_changed": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your email has been changed to %{email}.",
        "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
        "subject": "Email Changed"
      },
      "password_change": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your password has been changed.",
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "action": "Change my password",
        "greeting": "Hello %{recipient}!",
        "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
        "instruction_2": "If you didn't request this, please ignore this email.",
        "instruction_3": "Your password won't change until you access the link above and create a new one.",
        "subject": "Reset password instructions"
      },
      "unlock_instructions": {
        "action": "Unlock my account",
        "greeting": "Hello %{recipient}!",
        "instruction": "Click the link below to unlock your account:",
        "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
        "subject": "Unlock instructions"
      }
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "change_my_password": "Change my password",
        "change_your_password": "Change your password",
        "confirm_new_password": "Confirm new password",
        "new_password": "New password"
      },
      "new": {
        "forgot_your_password": "Forgot your password?",
        "send_me_reset_password_instructions": "Send me reset password instructions"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Your password has been changed successfully. You are now signed in.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
      "edit": {
        "are_you_sure": "Are you sure?",
        "cancel_my_account": "Cancel my account",
        "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
        "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
        "title": "Edit %{resource}",
        "unhappy": "Unhappy?",
        "update": "Update",
        "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
      },
      "new": {
        "sign_up": "Sign up"
      },
      "signed_up": "Welcome! You have signed up successfully.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Your account has been updated successfully.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "sign_in": "Log in"
      },
      "signed_in": "Signed in successfully.",
      "signed_out": "Signed out successfully."
    },
    "shared": {
      "links": {
        "back": "Back",
        "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
        "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
        "forgot_your_password": "Forgot your password?",
        "sign_in": "Log in",
        "sign_in_with_provider": "Sign in with %{provider}",
        "sign_up": "Sign up"
      },
      "minimum_password_length": {
        "one": "(%{count} character minimum)",
        "other": "(%{count} characters minimum)"
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": "Resend unlock instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
    }
  },
  "download": "Download",
  "edit": "Edit",
  "edit_object": "Edit",
  "employees": {
    "edit": {
      "title": "Edit Employee"
    },
    "form": {
      "email_note": "Must be a @gmail.com or @balrock.lv email.",
      "email_placeholder": "Enter the employee’s email",
      "first_name_note": "The first name cannot contain digits.",
      "first_name_placeholder": "Enter the employee’s first name",
      "last_name_note": "The last name cannot contain digits.",
      "last_name_placeholder": "Enter the employee’s last name"
    },
    "index": {
      "employee_enabled": "System access",
      "subtitle": "Employee and access management",
      "title": "Employees"
    },
    "new": {
      "title": "Add New Employee"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "was already confirmed, please try signing in",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "has expired, please request a new one",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "not found",
      "not_locked": "was not locked",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    }
  },
  "explosive_unit": "Unit",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "subtitle": "Scan a code or enter a number and choose the next action",
      "title": "Explosive Quantity Correction"
    },
    "index": {
      "title": "Erroneous Records"
    },
    "location": {
      "removed": "-- (Manually Deleted)",
      "used": "Used - %{destination_name}",
      "warehouse": "Warehouse"
    },
    "new": {
      "drop_files": "Drop files here",
      "import": "Import",
      "upload_note": "Choose one or more .xml or .xlsx files."
    },
    "warehouse_movement": {
      "entry_mode_label": "Entry mode",
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "process_range": "Process Range",
      "range_end": "Range End",
      "range_end_placeholder": "e.g. 275998",
      "range_entry": "Range Entry",
      "range_entry_title": "Range entry:",
      "range_start": "Range Start",
      "range_start_placeholder": "e.g. 275961",
      "single_entry": "Single Entry",
      "subtitle": "Choose the destination warehouse, then scan a code or enter a number",
      "title": "Move Explosives Between Warehouses",
      "warehouse_select_label": "Destination warehouse",
      "warehouse_select_placeholder": "Choose a warehouse"
    }
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e6177b8 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/common_pluralizations/one_other.rb:7 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Item weight and waybill settings",
      "title": "Item Settings"
    },
    "item_setting_row": {
      "weight_note": "Default weight"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Error!"
    },
    "correction_code_scanner": {
      "camera_alert": "Camera unavailable!",
      "correction_modal_title": "Quantity Correction",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "no_camera_permission": "You may not have granted permission or JavaScript is disabled.",
      "remove_explosives": "Delete from warehouse",
      "revive_explosives": "Return to inventory (no warehouse)",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "which_has": ", which has "
    },
    "file_upload": {
      "files_selected": " files selected",
      "import_notification": "Data is being imported, please wait."
    },
    "item_settings": {
      "success": "Success"
    },
    "loading_screen": {
      "please_wait": "Please wait..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Add selected items",
      "already_scanned": "Code already scanned",
      "camera_off": "Camera off!",
      "confirm_scanned_items": "I confirm that the scanned items and their statuses are correct",
      "confirm_used_items": "I confirm that all taken-out items were used on site",
      "error_occurred": "An error occurred",
      "failed_to_remove_item": "Error removing item. Try again or contact the administrator!",
      "item_already_scanned": "Item(s) already scanned.",
      "item_returnable": "Returnable",
      "item_used": "Used",
      "items_return_confirmation": "Do you want to return the following items?",
      "items_take_confirmation": "Do you want to take out the following items?",
      "no_items_scanned": "No items scanned",
      "range_modal_title": "Add items from range",
      "refresh_for_camera": "To turn the camera back on, please refresh the page!",
      "return_scanned": "The scanned items will be considered returned to the warehouse.",
      "scan_returnable_items": "Scanning returned items",
      "scan_used_items": "Used item scanning mode",
      "writeoff_scanned": "The scanned items will be considered used at the site. !! All taken-out items in the same package as the scanned item will be returned !!"
    },
    "warehouse_movement": {
      "confirm_move": "Confirm Move",
      "current_warehouse_name": "Warehouse",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "from_warehouse": "From %{warehouse}",
      "included_ids": "Included IDs (%{included} / %{total})",
      "items_badge": "%{count} Items",
      "modal_title": "Move Explosives Between Warehouses",
      "modal_title_short": "Move Explosives",
      "move_error": "An error occurred while moving items; please check the item list.",
      "move_success": "Explosives moved successfully",
      "move_to_button": "Move",
      "move_warehouse_info": "Move from #{from} to #{to}",
      "no_items_found": "No items were found in the given number range",
      "no_items_selected": "Select at least one item to move",
      "range_failures_preview": "%{count} items cannot be moved (e.g. %{examples}).",
      "range_label": "Range: %{start} → %{end}",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "subtitle_range": "Choose the destination warehouse, then enter or scan a number range",
      "to_warehouse": "To %{warehouse}",
      "total_items": "%{count} Items",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "No destination warehouse selected",
      "which_has": ", which has "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Got it",
      "confirmation": "Please confirm.",
      "title": "Error!"
    },
    "application": {
      "title": "Balrock Warehouse Management"
    },
    "camera_switch": {
      "use_camera": "Use Camera"
    },
    "confirmation_modal": {
      "confirm": "Confirm",
      "confirmation": "Have you used all the taken-out items?",
      "title": "Confirmation"
    },
    "delete_modal": {
      "confirmation": "Are you sure you want to delete %{deletable_object}?",
      "title": "Delete Confirmation"
    },
    "external_scanner": {
      "item_number_placeholder": "Manual number entry",
      "search": "Search",
      "title": "Manual entry or external scanner:"
    },
    "loading_overlay": {
      "please_wait": "Please wait..."
    },
    "sidebar": {
      "additional_code_printouts": "Additional Code Printing",
      "back": "Back",
      "correction": "Amount Correction",
      "home": "Home",
      "language": "Language",
      "logout": "Log Out",
      "logs": "Event List",
      "menu": "Menu",
      "receive_explosives": "Receive",
      "reports": "Reports",
      "return": "Return",
      "settings": {
        "destinations": "Sites",
        "employees": "Employees",
        "item_settings": "Item Settings",
        "title": "Settings",
        "vehicles": "Vehicles"
      },
      "takeout": "Take Out",
      "title": "Balrock Explosives Warehouse",
      "warehouse_movement": "Warehouse Movement",
      "warehouses": "Warehouses",
      "waybills": "Waybills"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Consolidated report (all warehouses)",
      "description": "Please select which warehouses to include in the report:",
      "prepare_report": "Prepare Report",
      "title": "Select Warehouses"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Number of corrected items:",
      "corrected_explosives_table": "Corrected Explosives",
      "correction_action": "Correction action:",
      "correction_date": "Date:",
      "deletion": "❌ Deletion",
      "employee": "Correction performed by:",
      "return": "✅ Returned to warehouse",
      "title": "Explosive Corrections Report"
    },
    "helper_row": {
      "changes": "Changes",
      "corrected_explosives_count": "Number of corrected explosives",
      "correction_action": "Correction action",
      "deletion": "Deletion",
      "edited": "Edited",
      "edited_object": "Edited item",
      "error": "Something went wrong",
      "imported_explosives_count": "Number of added explosives",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "movement_route": "Movement route",
      "precise_time": "Precise time",
      "return": "Return to warehouse",
      "returned_explosives_count": "Number of returned explosives",
      "taken_explosives_count": "Number of taken-out explosives",
      "takeout_responsible_employee": "Person responsible for takeout (creator)",
      "to_overview": "To overview",
      "used_explosives_count": "Used explosives count",
      "used_explosives_weight": "Used explosives weight"
    },
    "index": {
      "filtering": "Filtering",
      "subtitle": "Events are sorted in descending order by date",
      "title": "Activity Log"
    },
    "log_querry": {
      "clear_filters": "Clear Filters",
      "filter": "Filter"
    },
    "log_table": {
      "no_results": "Nothing found matching the given criteria"
    },
    "warehouse_moved_explosives": {
      "employee": "Moved by:",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "moved_explosives_table": "Moved explosives",
      "movement_date": "Date:",
      "title": "Explosives moved between warehouses"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Active explosives takeouts:",
      "current_employee": "User:",
      "employee_admin": "Administrator",
      "employee_regular": "Employee",
      "employee_role": "Status:",
      "explosives_in_warehouse": "Number of explosives in warehouse:",
      "no_actions": "You have not performed any actions yet.",
      "previous_actions": "Your latest actions:",
      "title": "Balrock Explosives Warehouse Management"
    }
  },
  "new_object": "Add",
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Billion",
            "other": "Billion"
          },
          "million": {
            "one": "Million",
            "other": "Million"
          },
          "quadrillion": {
            "one": "Quadrillion",
            "other": "Quadrillion"
          },
          "thousand": {
            "one": "Thousand",
            "other": "Thousand"
          },
          "trillion": {
            "one": "Trillion",
            "other": "Trillion"
          },
          "unit": {
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x00007fc57e632c70 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x00007fc57e632c98 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Page %{page_input} of %{pages}",
    "info": {
      "multiple_pages": "Displaying %{item_name} <b>%{from}-%{to}</b> of <b>%{count}</b> in total",
      "no_items": "No %{item_name} found",
      "single_page": "Displaying <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Record",
      "other": "Records"
    },
    "items_selector_js": "Include %{items_input} %{item_name} records on the page",
    "nav": {
      "gap": "&hellip;",
      "next": "Next&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Previous"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Failed to create printable codes",
      "invalid_code_type": "Invalid item code type"
    },
    "index": {
      "no_results": "Nothing found",
      "package_search": "Search for boxes of items to print by name",
      "package_search_placeholder": "Name or part of it",
      "search": "Search",
      "title": "Duplicate Item Code Printing"
    },
    "table_row": {
      "get_pdf": "Get PDF code sheet"
    }
  },
  "remove": "Remove",
  "reports": {
    "index": {
      "available_explosives_count": "Currently, %{count} items are available",
      "available_explosives_report": "Available Explosives",
      "date_range": "Time Period",
      "explosive_movement_report": "Explosive Movement within a Time Period",
      "explosive_summary": "Explosive Stock in Warehouse by Name",
      "explosives_in_warehouse": "Currently in the warehouse:",
      "prepare_report": "Prepare",
      "tab_all": "All",
      "tab_without_warehouse": "Without warehouse",
      "title": "Available System Reports (.xlsx)"
    },
    "quick_report_tab": {
      "total_amount": "Total:",
      "units": "Units",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Location",
              "Responsible"
            ],
            "no_employee": "No responsible person assigned",
            "report_row_title": "Overview of Available Explosives %{date}",
            "report_warehouse_row_title": "Overview of Available Explosives in Warehouse %{warehouse} - %{date}",
            "warehouse_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Responsible"
            ],
            "worksheet_title": "Available Explosives"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "ActiveTakeout-%{index}-%{date}",
              "returned": "ReturnedTakeout-%{index}-%{date}"
            },
            "states": {
              "active": "taken out",
              "returned": "returned",
              "used": "used"
            },
            "takeout_explosives_headers": [
              "Code",
              "Name",
              "Box",
              "Package",
              "Explosive",
              "Import File",
              "Status"
            ],
            "takeout_info_headers": [
              "Employee",
              "Work Site",
              "Vehicle",
              "Status",
              "Number of Taken-Out Items",
              "Number of Used Items"
            ],
            "worksheet_title": "Explosives Takeout/Return Report"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Driver",
    "employee": "Employee",
    "manager": "Manager"
  },
  "save": "Save",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "All units successfully written off!",
        "failed_to_return": "{count} units could not be returned.",
        "returned": "Units successfully returned!",
        "server_error": "Server error returning units!"
      },
      "take_explosives": {
        "failed_to_take": "{count} units could not be taken.",
        "server_error": "Server error taking units!",
        "success": "Units successfully taken"
      },
      "type": "Explosive"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Add to warehouse",
      "expand": "Expand",
      "title": "Explosives without warehouse"
    }
  },
  "state": "Enabled",
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Waybill FROM",
    "button_title_to": "Waybill TO",
    "custom_item_form_row": {
      "not_included_in_waybill": "This item is not included in the waybill"
    },
    "edit": {
      "manual_items": "Manually Enterable Items",
      "title": "Editing Waybill %{number}",
      "view_waybill": "View Waybill",
      "waybill_persons": "Waybill Persons"
    },
    "index": {
      "subtitle": "List of all created waybills",
      "title": "Waybills"
    },
    "pdf": {
      "default_packaging_type": "cardboard box",
      "failed_to_create": "Failed to create waybill",
      "header": {
        "date": "Date",
        "route": "Route",
        "waybill": "Waybill",
        "waybill_nr": "WAYBILL No."
      },
      "item_counts": {
        "kogus": "Quantity",
        "laohoidja": "Warehouse keeper:",
        "seeria_nr": "Taken:",
        "tagastus": "Return:",
        "vedaja_lohkaja": "Carrier/Blaster/Blast master:",
        "veokiri_nr": "WAYBILL nr:"
      },
      "legal_entity": {
        "address": "Address",
        "reg_number": "Reg. No.",
        "title": "Legal Entity",
        "vat_number": "VAT Reg. No."
      },
      "no_custom_item_data": "Failed to create waybill because all items in it do not have a specified weight",
      "sender_receiver": "Sender/Receiver:",
      "signatures": {
        "carrier_received": "Substance received by carrier:",
        "carrier_returned": "Substance remainder returned by carrier to warehouse keeper:",
        "carrier_title": "Carrier:",
        "date": "Date:",
        "issuer_title": "Persons responsible for goods issuance:",
        "miner_received": "Substance received from carrier by miner:",
        "miner_returned": "Substance remainder returned by miner to carrier:",
        "name": "Name, Surname:",
        "name_signature_date": "name, signature, date",
        "receiver_title": "Persons responsible for goods receipt:",
        "responsible_title": "Responsible person:",
        "signature": "Signature:",
        "warehouse_keeper_issued": "Waybill prepared and substance issued by warehouse keeper",
        "warehouse_keeper_received": "Substance remainder received by warehouse keeper:"
      },
      "table": {
        "aine_code": "Substance code",
        "consumption": "Consumption\nkg/pcs/m",
        "description": "Description",
        "name": "Name",
        "package_count": "Package count (pcs.)",
        "packaging": "Packaging",
        "quantity": "Quantity (pcs.)",
        "remainder": "Remainder\nkg/pcs/m",
        "source_warehouse": "Warehouse",
        "substance_code": "Substance code",
        "substance_name_description": "Substance name and description",
        "taken": "Taken\nkg/pcs/m",
        "total": "Total:",
        "total_weight": "Total weight (kg):",
        "uro_number": "URO No.",
        "weight_kg": "Weight (kg)"
      },
      "total_cargo": "Total cargo:",
      "transport": {
        "self_transport": "self-transport",
        "type": "Transport type",
        "vehicle_reg": "Vehicle Reg. No."
      },
      "units": {
        "kg": "kg",
        "pcs": "pcs"
      }
    },
    "table_row": {
      "to_destination": "To destination",
      "to_warehouse": "To warehouse"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "pcs."
    },
    "index": {
      "active_title": "Active takeouts (in progress)",
      "cta": "Click on one or create a new one!",
      "historical_title": "Completed takeouts (last 50)",
      "new_takeout": "New Takeout",
      "no_active_takeouts": "There are no active takeouts.",
      "no_historical_takeouts": "No completed takeouts yet.",
      "no_takeouts": "There are no takeouts yet.",
      "type": "Takeout"
    },
    "new": {
      "add_destination": "Add",
      "choose_destination": "Choose work site",
      "choose_vehicle": "Choose vehicle",
      "destinations": "Work sites",
      "drag_to_reorder": "Drag to reorder",
      "mandatory_field": "This field is required"
    },
    "returns": {
      "p_text": "Click on the relevant takeout to perform the return",
      "return": "Return"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Available units:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Remaining units:",
      "title": "Discard All remaining Explosives"
    },
    "scan_takeout_explosives": {
      "title": "Take Out Selected Explosives"
    },
    "scanner": {
      "delete_takeout": "Delete takeout",
      "destination": "Site: %{destination}",
      "item_count": "Number of items: %{count}",
      "no_camera_alert": "Camera unavailable",
      "no_camera_subalert": "You might not have granted permission to use the camera",
      "scan_only_used_explosives": "Select <strong>only</strong> items used on site",
      "scanned": "Scanned:",
      "this_takeout": "this takeout",
      "title": "Package Code Scanning",
      "vehicle": "Vehicle: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Active",
      "date": "Date:",
      "destination": "Work Site:",
      "employee": "Responsible for takeout:",
      "inactive_takeout": "❌ - Inactive/Returned",
      "state": "Status:",
      "subtitle": "*The table can be scrolled horizontally on narrow mobile devices",
      "title": "Explosives Takeout/Return Overview",
      "title_2": "Taken-Out Explosive Items",
      "title_3": "Used explosive items are highlighted in red",
      "vehicle": "Vehicle:"
    },
    "table": {
      "button_edit_return": "Edit",
      "button_return_to_warehouse": "Return to warehouse",
      "button_take_out": "Take Out",
      "button_to_next_object": "To next object",
      "items": "%{count} items",
      "title": "Explosives %{action}"
    },
    "taken_explosives": {
      "no_person": "No responsible person assigned",
      "person": "Taken out by: %{name}",
      "title": "Taken-Out Items:",
      "unknown": "unknown"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "vehicles": {
    "edit": {
      "title": "Edit Vehicle"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Important to keep the license plate format"
    },
    "index": {
      "delete_modal_text": "vehicle %{number_plate}",
      "subtitle": "Management of vehicles able to carry explosives",
      "title": "Vehicles"
    },
    "new": {
      "title": "Add New Vehicle"
    }
  },
  "view": "View",
  "warehouses": {
    "edit": {
      "title": "Editing %{warehouse_name}"
    },
    "form": {
      "country_code_hint": "Use the ISO 3166-1 alpha-2 code, e.g. LV.",
      "latitude_hint": "Use the latitude, e.g. 56.96130.",
      "longitude_hint": "Use the longitude, e.g. 24.12540.",
      "responsible_person_prompt": "Choose a responsible person"
    },
    "index": {
      "subtitle": "Warehouse list and management",
      "title": "Warehouses"
    },
    "new": {
      "title": "Add New Warehouse"
    },
    "show": {
      "details_title": "Warehouse details",
      "explosives_title": "Explosives in warehouse",
      "map_title": "Location on map",
      "no_explosives": "No explosives are currently stored in this warehouse."
    }
  }
});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
  "actions": "Actions",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Address",
        "name": "Name"
      },
      "employee": {
        "active": "Active",
        "admin": "Super-rights",
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "role": "Role"
      },
      "explosive": {
        "available": "Available",
        "box_number": "Box Number",
        "code": "Item Code",
        "delivery_date": "Delivery Date",
        "grouped_number": "Grouped number",
        "import_name": "Imported File Name",
        "item_number": "Item Number",
        "location": "Location",
        "manufacturer": "Manufacturer",
        "middlebox_number": "Package Number",
        "number_type": "Number type",
        "product_name": "Product Name",
        "product_number": "Product Number",
        "reason": "Reason",
        "takeout": "Takeout",
        "unknown_type": "Unknown type"
      },
      "item_setting": {
        "aine_code": "Substance Code",
        "countable_unit": "Countable Unit",
        "countable_units": {
          "units": "Units",
          "weight": "Weight"
        },
        "include_in_waybills": "Include in Waybills",
        "item_count": "Number of Items",
        "item_name_display": "Display Name",
        "item_name_import": "Item Name",
        "manually_created": "Manually Created",
        "set_weight_manually": "Manual Weight",
        "uro_number": "URO Number",
        "waybill_position": "Waybill Position",
        "weight": "Weight"
      },
      "log": {
        "action": "Action",
        "actions": {
          "atgriešana": "Return",
          "dzēšana": "Deletion",
          "izņemšana": "Takeout",
          "korekcija": "Correction",
          "noliktavas pārvietošana": "Warehouse transfer",
          "pievienošana": "Addition",
          "rediģēšana": "Editing",
          "saņemšana": "Data import",
          "starp-objektu pārvietošana": "Inter-object transfer"
        },
        "author": "Performed By",
        "corrected_explosives": "Corrected Explosives",
        "current_destination": "Current Location",
        "date": "Date",
        "destination": "Work Site",
        "destinations": "Work Sites",
        "employee": "Employee",
        "id_number": "ID Number",
        "import_name": "Import File",
        "notes": "Notes",
        "takeout": "Takeout",
        "takeout_waybill": "Takeout Waybill",
        "takeout_waybill_custom_items": "Manual Row in the Takeout Waybill",
        "vehicle": "Vehicle"
      },
      "pdf_code_printout": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "report": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "takeout": {
        "active": "Active?",
        "date": "Date",
        "destination": "Work Site",
        "employee": "Creator",
        "removed": "Removed",
        "vehicle": "Vehicle",
        "waybills": "Waybills"
      },
      "takeout_waybill": {
        "date": "Date",
        "destination": "Site",
        "direction": "Direction",
        "employee": "Employee",
        "initally_edited": "Edited",
        "issuance_person": "Issuance Person",
        "issuer": "Sender",
        "legal_entity": "Legal Entity",
        "number": "Number",
        "receiver": "Receiver",
        "receiving_person": "Receiving Person",
        "route": "Route",
        "scope": "Waybill scope",
        "takeout": "Takeout",
        "to_object": "To Site",
        "vehicle": "Vehicle"
      },
      "takeout_waybill_custom_item": {
        "amount": "Quantity",
        "item_setting": "Item Settings",
        "name": "Name",
        "package_name": "Package",
        "takeout_waybill": "Takeout Waybill",
        "weight": "Weight"
      },
      "user": {
        "confirmation_sent_at": "Confirmation sent at",
        "confirmation_token": "Confirmation token",
        "confirmed_at": "Confirmed at",
        "created_at": "Created at",
        "current_password": "Current password",
        "current_sign_in_at": "Current sign in at",
        "current_sign_in_ip": "Current sign in IP",
        "email": "Email",
        "encrypted_password": "Encrypted password",
        "failed_attempts": "Failed attempts",
        "last_sign_in_at": "Last sign in at",
        "last_sign_in_ip": "Last sign in IP",
        "locked_at": "Locked at",
        "password": "Password",
        "password_confirmation": "Password confirmation",
        "remember_created_at": "Remember created at",
        "remember_me": "Remember me",
        "reset_password_sent_at": "Reset password sent at",
        "reset_password_token": "Reset password token",
        "sign_in_count": "Sign in count",
        "unconfirmed_email": "Unconfirmed email",
        "unlock_token": "Unlock token",
        "updated_at": "Updated at"
      },
      "vehicle": {
        "active": "Active",
        "number_plate": "License Plate"
      },
      "warehouse": {
        "address": "Address",
        "city": "City",
        "country_code": "Country Code",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "name": "Name",
        "responsible_employee": "Responsible Person",
        "zip": "Postal Code"
      }
    },
    "created_at": "Created",
    "errors": {
      "destination": {
        "adress_taken": "Address has already been taken",
        "generic_error": "Error in input data",
        "name_blank": "Name can't be blank"
      },
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Employee already has identical takeout",
        "missing_destinations": "Must have at least one destination"
      },
      "takeout_waybill": {
        "destination_unknown": "Unknown"
      }
    },
    "models": {
      "destination": "Work Site",
      "employee": "Employee",
      "explosive": "Explosive",
      "item_setting": "Item Setting",
      "log": "Activity Log",
      "pdf_code_printout": "PDF Code Printout",
      "report": "Report",
      "takeout": "Explosives Takeout",
      "takeout_waybill": "Waybill",
      "takeout_waybill_custom_item": "Manually Entered Item",
      "user": {
        "one": "User",
        "other": "Users"
      },
      "vehicle": "Vehicle",
      "warehouse": "Warehouse"
    },
    "removed": "Removed",
    "updated_at": "Updated"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Back to login",
        "description": "Choose a new password for your account.",
        "password_confirmation_label": "Confirm new password",
        "password_label": "New password",
        "submit": "Update password",
        "title": "Set your password"
      },
      "new": {
        "back_to_login": "Back to login",
        "description": "Enter your work email to receive a password setup link.",
        "submit": "Send link",
        "title": "Request password link"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "or",
        "email_login_button": "Email login",
        "email_login_title": "Email login with your work email",
        "google_auth": "Log In with Google",
        "password_label": "Password",
        "password_link_text": "Request password link",
        "remember_me": "Remember me",
        "title": "Log In to BALROCK Warehouse Management"
      }
    }
  },
  "back": "Back",
  "cancel": "Cancel",
  "controllers": {
    "application": {
      "not_logged_in": "You must log in to view the requested page!",
      "not_permitted": "You do not have permission to view the requested page!",
      "report_ready": "Your report: %{report_name} is ready! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Invalid email or password. Please check your details.",
        "no_access": "Your access to the system is denied. Contact the administration.",
        "server_error": "A server error occurred. Please try again."
      }
    },
    "destinations": {
      "object_added": "Object successfully added",
      "object_edited": "Object successfully edited"
    },
    "employees": {
      "employee_added": "Employee successfully added",
      "employee_added_with_invite": "Employee added and password setup email sent",
      "employee_edited": "Employee data successfully updated",
      "password_email_failed": "Employee added, but sending the password setup email failed."
    },
    "explosives": {
      "all_items_moved": "All selected items successfully moved",
      "all_items_removed": "All units successfully removed",
      "all_items_returned": "All units successfully returned to storage",
      "database_updated": "Database updated",
      "failed_import_file_count": "%{count_failed} out of %{count_total} failed to import",
      "failed_to_add": "%{count} units failed to be added",
      "failed_to_import": "Failed to import file %{filename} because %{reason}",
      "import_in_progress": "Import in progress. You will be notified of the result.",
      "item_already_at_destination": "already at destination",
      "item_not_found": "not found",
      "item_removed": "removed",
      "item_unavailable": "unavailable",
      "multiple_warehouses": "Error! Scanned units are located in multiple warehouses, please clarify their numbers.",
      "no_files_selected": "No files selected",
      "no_item_settings": "Some units are not linked to settings",
      "no_items_found": "No items were found in the given number range",
      "no_warehouse": "--",
      "not_all_items_moved": "An error occurred while moving units; please check the item list.",
      "not_all_states_changed": "An error occurred, and some unit statuses did not change",
      "not_available_for_movement": "Explosive item is not available",
      "partial_items_moved": "Successfully moved %{moved} selected items. %{failed} selected items failed (e.g. %{examples}).",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "range_too_large": "Range is too large (max %{max} items)",
      "warehouse_not_selected": "No destination warehouse selected"
    },
    "item_settings": {
      "created": "Unit settings successfully created",
      "deleted": "Unit settings successfully deleted",
      "edited": "Unit settings successfully updated",
      "failed_to_create": "Error creating unit settings",
      "failed_to_edit": "Error updating unit settings",
      "unable_to_delete": "Cannot delete because it is linked to explosives"
    },
    "reports": {
      "error": "An error occurred. Please try to generate the report again!",
      "no_period": "Specify the explosives movement report period!",
      "no_report": "Report file not found!",
      "preparation_error": "An error occurred while preparing report %{report_name}"
    },
    "sessions": {
      "invalid_credentials": "Invalid email or password. Please check your details.",
      "no_access": "Your access to the system is denied. Contact the administration.",
      "server_error": "A server error occurred. Please try again."
    },
    "takeout_waybills": {
      "data_updated": "Waybill data updated",
      "waybill_edited": "Waybill already edited"
    },
    "takeouts": {
      "add_back_to_warehouse": "Place the units back in the correct warehouse!",
      "item_not_removed": "Error, failed to remove unit",
      "item_removed": "Unit successfully removed",
      "need_more_data": "Please specify waybill details",
      "no_access": "You do not have access rights",
      "no_access_system_error": "A system error occurred related to your access authorization",
      "scan_to_next_object_title": "Scan units to take to %{destination}",
      "takeout_confirmation_modal_title": "Are you sure you want to go to %{destination} with the units:",
      "takeout_exists": "Error! Such a takeout already exists!",
      "takeout_unavailable": "Takeout unavailable",
      "to_next_object_button": "Move to %{destination}"
    },
    "vehicles": {
      "created": "Vehicle successfully added",
      "edited": "Vehicle successfully edited"
    },
    "warehouses": {
      "unable_to_delete": "Failed to delete the warehouse",
      "warehouse_created": "Warehouse successfully created",
      "warehouse_deleted": "Warehouse successfully deleted",
      "warehouse_edited": "Warehouse data successfully updated"
    }
  },
  "create": "Create",
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "delete": "Delete",
  "destinations": {
    "edit": {
      "title": "Edit Site"
    },
    "form": {
      "adress_note": "The address must be unique.",
      "adress_placeholder": "Site address",
      "name_placeholder": "Site name"
    },
    "new": {
      "title": "Add New Site"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Your email address has been successfully confirmed.",
      "new": {
        "resend_confirmation_instructions": "Resend confirmation instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
    },
    "failure": {
      "already_authenticated": "You are already signed in.",
      "inactive": "Your account is not activated yet.",
      "invalid": "Invalid %{authentication_keys} or password.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Your account is locked.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Your session expired. Please sign in again to continue.",
      "unauthenticated": "You need to sign in or sign up before continuing.",
      "unconfirmed": "You have to confirm your email address before continuing."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Confirm my account",
        "greeting": "Welcome %{recipient}!",
        "instruction": "You can confirm your account email through the link below:",
        "subject": "Confirmation instructions"
      },
      "email_changed": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your email has been changed to %{email}.",
        "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
        "subject": "Email Changed"
      },
      "password_change": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your password has been changed.",
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "action": "Change my password",
        "greeting": "Hello %{recipient}!",
        "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
        "instruction_2": "If you didn't request this, please ignore this email.",
        "instruction_3": "Your password won't change until you access the link above and create a new one.",
        "subject": "Reset password instructions"
      },
      "unlock_instructions": {
        "action": "Unlock my account",
        "greeting": "Hello %{recipient}!",
        "instruction": "Click the link below to unlock your account:",
        "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
        "subject": "Unlock instructions"
      }
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "change_my_password": "Change my password",
        "change_your_password": "Change your password",
        "confirm_new_password": "Confirm new password",
        "new_password": "New password"
      },
      "new": {
        "forgot_your_password": "Forgot your password?",
        "send_me_reset_password_instructions": "Send me reset password instructions"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Your password has been changed successfully. You are now signed in.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
      "edit": {
        "are_you_sure": "Are you sure?",
        "cancel_my_account": "Cancel my account",
        "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
        "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
        "title": "Edit %{resource}",
        "unhappy": "Unhappy?",
        "update": "Update",
        "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
      },
      "new": {
        "sign_up": "Sign up"
      },
      "signed_up": "Welcome! You have signed up successfully.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Your account has been updated successfully.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "sign_in": "Log in"
      },
      "signed_in": "Signed in successfully.",
      "signed_out": "Signed out successfully."
    },
    "shared": {
      "links": {
        "back": "Back",
        "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
        "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
        "forgot_your_password": "Forgot your password?",
        "sign_in": "Log in",
        "sign_in_with_provider": "Sign in with %{provider}",
        "sign_up": "Sign up"
      },
      "minimum_password_length": {
        "one": "(%{count} character minimum)",
        "other": "(%{count} characters minimum)"
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": "Resend unlock instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
    }
  },
  "download": "Download",
  "edit": "Edit",
  "edit_object": "Edit",
  "employees": {
    "edit": {
      "title": "Edit Employee"
    },
    "form": {
      "email_note": "Must be a @gmail.com or @balrock.lv email.",
      "email_placeholder": "Enter the employee’s email",
      "first_name_note": "The first name cannot contain digits.",
      "first_name_placeholder": "Enter the employee’s first name",
      "last_name_note": "The last name cannot contain digits.",
      "last_name_placeholder": "Enter the employee’s last name"
    },
    "index": {
      "employee_enabled": "System access",
      "subtitle": "Employee and access management",
      "title": "Employees"
    },
    "new": {
      "title": "Add New Employee"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "was already confirmed, please try signing in",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "has expired, please request a new one",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "not found",
      "not_locked": "was not locked",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    }
  },
  "explosive_unit": "Unit",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "subtitle": "Scan a code or enter a number and choose the next action",
      "title": "Explosive Quantity Correction"
    },
    "index": {
      "title": "Erroneous Records"
    },
    "location": {
      "removed": "-- (Manually Deleted)",
      "used": "Used - %{destination_name}",
      "warehouse": "Warehouse"
    },
    "new": {
      "drop_files": "Drop files here",
      "import": "Import",
      "upload_note": "Choose one or more .xml or .xlsx files."
    },
    "warehouse_movement": {
      "entry_mode_label": "Entry mode",
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "process_range": "Process Range",
      "range_end": "Range End",
      "range_end_placeholder": "e.g. 275998",
      "range_entry": "Range Entry",
      "range_entry_title": "Range entry:",
      "range_start": "Range Start",
      "range_start_placeholder": "e.g. 275961",
      "single_entry": "Single Entry",
      "subtitle": "Choose the destination warehouse, then scan a code or enter a number",
      "title": "Move Explosives Between Warehouses",
      "warehouse_select_label": "Destination warehouse",
      "warehouse_select_placeholder": "Choose a warehouse"
    }
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e6177b8 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/common_pluralizations/one_other.rb:7 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Item weight and waybill settings",
      "title": "Item Settings"
    },
    "item_setting_row": {
      "weight_note": "Default weight"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Error!"
    },
    "correction_code_scanner": {
      "camera_alert": "Camera unavailable!",
      "correction_modal_title": "Quantity Correction",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "no_camera_permission": "You may not have granted permission or JavaScript is disabled.",
      "remove_explosives": "Delete from warehouse",
      "revive_explosives": "Return to inventory (no warehouse)",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "which_has": ", which has "
    },
    "file_upload": {
      "files_selected": " files selected",
      "import_notification": "Data is being imported, please wait."
    },
    "item_settings": {
      "success": "Success"
    },
    "loading_screen": {
      "please_wait": "Please wait..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Add selected items",
      "already_scanned": "Code already scanned",
      "camera_off": "Camera off!",
      "confirm_scanned_items": "I confirm that the scanned items and their statuses are correct",
      "confirm_used_items": "I confirm that all taken-out items were used on site",
      "error_occurred": "An error occurred",
      "failed_to_remove_item": "Error removing item. Try again or contact the administrator!",
      "item_already_scanned": "Item(s) already scanned.",
      "item_returnable": "Returnable",
      "item_used": "Used",
      "items_return_confirmation": "Do you want to return the following items?",
      "items_take_confirmation": "Do you want to take out the following items?",
      "no_items_scanned": "No items scanned",
      "range_modal_title": "Add items from range",
      "refresh_for_camera": "To turn the camera back on, please refresh the page!",
      "return_scanned": "The scanned items will be considered returned to the warehouse.",
      "scan_returnable_items": "Scanning returned items",
      "scan_used_items": "Used item scanning mode",
      "writeoff_scanned": "The scanned items will be considered used at the site. !! All taken-out items in the same package as the scanned item will be returned !!"
    },
    "warehouse_movement": {
      "confirm_move": "Confirm Move",
      "current_warehouse_name": "Warehouse",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "from_warehouse": "From %{warehouse}",
      "included_ids": "Included IDs (%{included} / %{total})",
      "items_badge": "%{count} Items",
      "modal_title": "Move Explosives Between Warehouses",
      "modal_title_short": "Move Explosives",
      "move_error": "An error occurred while moving items; please check the item list.",
      "move_success": "Explosives moved successfully",
      "move_to_button": "Move",
      "move_warehouse_info": "Move from #{from} to #{to}",
      "no_items_found": "No items were found in the given number range",
      "no_items_selected": "Select at least one item to move",
      "range_failures_preview": "%{count} items cannot be moved (e.g. %{examples}).",
      "range_label": "Range: %{start} → %{end}",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "subtitle_range": "Choose the destination warehouse, then enter or scan a number range",
      "to_warehouse": "To %{warehouse}",
      "total_items": "%{count} Items",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "No destination warehouse selected",
      "which_has": ", which has "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Got it",
      "confirmation": "Please confirm.",
      "title": "Error!"
    },
    "application": {
      "title": "Balrock Warehouse Management"
    },
    "camera_switch": {
      "use_camera": "Use Camera"
    },
    "confirmation_modal": {
      "confirm": "Confirm",
      "confirmation": "Have you used all the taken-out items?",
      "title": "Confirmation"
    },
    "delete_modal": {
      "confirmation": "Are you sure you want to delete %{deletable_object}?",
      "title": "Delete Confirmation"
    },
    "external_scanner": {
      "item_number_placeholder": "Manual number entry",
      "search": "Search",
      "title": "Manual entry or external scanner:"
    },
    "loading_overlay": {
      "please_wait": "Please wait..."
    },
    "sidebar": {
      "additional_code_printouts": "Additional Code Printing",
      "back": "Back",
      "correction": "Amount Correction",
      "home": "Home",
      "language": "Language",
      "logout": "Log Out",
      "logs": "Event List",
      "menu": "Menu",
      "receive_explosives": "Receive",
      "reports": "Reports",
      "return": "Return",
      "settings": {
        "destinations": "Sites",
        "employees": "Employees",
        "item_settings": "Item Settings",
        "title": "Settings",
        "vehicles": "Vehicles"
      },
      "takeout": "Take Out",
      "title": "Balrock Explosives Warehouse",
      "warehouse_movement": "Warehouse Movement",
      "warehouses": "Warehouses",
      "waybills": "Waybills"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Consolidated report (all warehouses)",
      "description": "Please select which warehouses to include in the report:",
      "prepare_report": "Prepare Report",
      "title": "Select Warehouses"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Number of corrected items:",
      "corrected_explosives_table": "Corrected Explosives",
      "correction_action": "Correction action:",
      "correction_date": "Date:",
      "deletion": "❌ Deletion",
      "employee": "Correction performed by:",
      "return": "✅ Returned to warehouse",
      "title": "Explosive Corrections Report"
    },
    "helper_row": {
      "changes": "Changes",
      "corrected_explosives_count": "Number of corrected explosives",
      "correction_action": "Correction action",
      "deletion": "Deletion",
      "edited": "Edited",
      "edited_object": "Edited item",
      "error": "Something went wrong",
      "imported_explosives_count": "Number of added explosives",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "movement_route": "Movement route",
      "precise_time": "Precise time",
      "return": "Return to warehouse",
      "returned_explosives_count": "Number of returned explosives",
      "taken_explosives_count": "Number of taken-out explosives",
      "takeout_responsible_employee": "Person responsible for takeout (creator)",
      "to_overview": "To overview",
      "used_explosives_count": "Used explosives count",
      "used_explosives_weight": "Used explosives weight"
    },
    "index": {
      "filtering": "Filtering",
      "subtitle": "Events are sorted in descending order by date",
      "title": "Activity Log"
    },
    "log_querry": {
      "clear_filters": "Clear Filters",
      "filter": "Filter"
    },
    "log_table": {
      "no_results": "Nothing found matching the given criteria"
    },
    "warehouse_moved_explosives": {
      "employee": "Moved by:",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "moved_explosives_table": "Moved explosives",
      "movement_date": "Date:",
      "title": "Explosives moved between warehouses"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Active explosives takeouts:",
      "current_employee": "User:",
      "employee_admin": "Administrator",
      "employee_regular": "Employee",
      "employee_role": "Status:",
      "explosives_in_warehouse": "Number of explosives in warehouse:",
      "no_actions": "You have not performed any actions yet.",
      "previous_actions": "Your latest actions:",
      "title": "Balrock Explosives Warehouse Management"
    }
  },
  "new_object": "Add",
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Billion",
            "other": "Billion"
          },
          "million": {
            "one": "Million",
            "other": "Million"
          },
          "quadrillion": {
            "one": "Quadrillion",
            "other": "Quadrillion"
          },
          "thousand": {
            "one": "Thousand",
            "other": "Thousand"
          },
          "trillion": {
            "one": "Trillion",
            "other": "Trillion"
          },
          "unit": {
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x00007fc57e632c70 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x00007fc57e632c98 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Page %{page_input} of %{pages}",
    "info": {
      "multiple_pages": "Displaying %{item_name} <b>%{from}-%{to}</b> of <b>%{count}</b> in total",
      "no_items": "No %{item_name} found",
      "single_page": "Displaying <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Record",
      "other": "Records"
    },
    "items_selector_js": "Include %{items_input} %{item_name} records on the page",
    "nav": {
      "gap": "&hellip;",
      "next": "Next&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Previous"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Failed to create printable codes",
      "invalid_code_type": "Invalid item code type"
    },
    "index": {
      "no_results": "Nothing found",
      "package_search": "Search for boxes of items to print by name",
      "package_search_placeholder": "Name or part of it",
      "search": "Search",
      "title": "Duplicate Item Code Printing"
    },
    "table_row": {
      "get_pdf": "Get PDF code sheet"
    }
  },
  "remove": "Remove",
  "reports": {
    "index": {
      "available_explosives_count": "Currently, %{count} items are available",
      "available_explosives_report": "Available Explosives",
      "date_range": "Time Period",
      "explosive_movement_report": "Explosive Movement within a Time Period",
      "explosive_summary": "Explosive Stock in Warehouse by Name",
      "explosives_in_warehouse": "Currently in the warehouse:",
      "prepare_report": "Prepare",
      "tab_all": "All",
      "tab_without_warehouse": "Without warehouse",
      "title": "Available System Reports (.xlsx)"
    },
    "quick_report_tab": {
      "total_amount": "Total:",
      "units": "Units",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Location",
              "Responsible"
            ],
            "no_employee": "No responsible person assigned",
            "report_row_title": "Overview of Available Explosives %{date}",
            "report_warehouse_row_title": "Overview of Available Explosives in Warehouse %{warehouse} - %{date}",
            "warehouse_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Responsible"
            ],
            "worksheet_title": "Available Explosives"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "ActiveTakeout-%{index}-%{date}",
              "returned": "ReturnedTakeout-%{index}-%{date}"
            },
            "states": {
              "active": "taken out",
              "returned": "returned",
              "used": "used"
            },
            "takeout_explosives_headers": [
              "Code",
              "Name",
              "Box",
              "Package",
              "Explosive",
              "Import File",
              "Status"
            ],
            "takeout_info_headers": [
              "Employee",
              "Work Site",
              "Vehicle",
              "Status",
              "Number of Taken-Out Items",
              "Number of Used Items"
            ],
            "worksheet_title": "Explosives Takeout/Return Report"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Driver",
    "employee": "Employee",
    "manager": "Manager"
  },
  "save": "Save",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "All units successfully written off!",
        "failed_to_return": "{count} units could not be returned.",
        "returned": "Units successfully returned!",
        "server_error": "Server error returning units!"
      },
      "take_explosives": {
        "failed_to_take": "{count} units could not be taken.",
        "server_error": "Server error taking units!",
        "success": "Units successfully taken"
      },
      "type": "Explosive"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Add to warehouse",
      "expand": "Expand",
      "title": "Explosives without warehouse"
    }
  },
  "state": "Enabled",
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Waybill FROM",
    "button_title_to": "Waybill TO",
    "custom_item_form_row": {
      "not_included_in_waybill": "This item is not included in the waybill"
    },
    "edit": {
      "manual_items": "Manually Enterable Items",
      "title": "Editing Waybill %{number}",
      "view_waybill": "View Waybill",
      "waybill_persons": "Waybill Persons"
    },
    "index": {
      "subtitle": "List of all created waybills",
      "title": "Waybills"
    },
    "pdf": {
      "default_packaging_type": "cardboard box",
      "failed_to_create": "Failed to create waybill",
      "header": {
        "date": "Date",
        "route": "Route",
        "waybill": "Waybill",
        "waybill_nr": "WAYBILL No."
      },
      "item_counts": {
        "kogus": "Quantity",
        "laohoidja": "Warehouse keeper:",
        "seeria_nr": "Taken:",
        "tagastus": "Return:",
        "vedaja_lohkaja": "Carrier/Blaster/Blast master:",
        "veokiri_nr": "WAYBILL nr:"
      },
      "legal_entity": {
        "address": "Address",
        "reg_number": "Reg. No.",
        "title": "Legal Entity",
        "vat_number": "VAT Reg. No."
      },
      "no_custom_item_data": "Failed to create waybill because all items in it do not have a specified weight",
      "sender_receiver": "Sender/Receiver:",
      "signatures": {
        "carrier_received": "Substance received by carrier:",
        "carrier_returned": "Substance remainder returned by carrier to warehouse keeper:",
        "carrier_title": "Carrier:",
        "date": "Date:",
        "issuer_title": "Persons responsible for goods issuance:",
        "miner_received": "Substance received from carrier by miner:",
        "miner_returned": "Substance remainder returned by miner to carrier:",
        "name": "Name, Surname:",
        "name_signature_date": "name, signature, date",
        "receiver_title": "Persons responsible for goods receipt:",
        "responsible_title": "Responsible person:",
        "signature": "Signature:",
        "warehouse_keeper_issued": "Waybill prepared and substance issued by warehouse keeper",
        "warehouse_keeper_received": "Substance remainder received by warehouse keeper:"
      },
      "table": {
        "aine_code": "Substance code",
        "consumption": "Consumption\nkg/pcs/m",
        "description": "Description",
        "name": "Name",
        "package_count": "Package count (pcs.)",
        "packaging": "Packaging",
        "quantity": "Quantity (pcs.)",
        "remainder": "Remainder\nkg/pcs/m",
        "source_warehouse": "Warehouse",
        "substance_code": "Substance code",
        "substance_name_description": "Substance name and description",
        "taken": "Taken\nkg/pcs/m",
        "total": "Total:",
        "total_weight": "Total weight (kg):",
        "uro_number": "URO No.",
        "weight_kg": "Weight (kg)"
      },
      "total_cargo": "Total cargo:",
      "transport": {
        "self_transport": "self-transport",
        "type": "Transport type",
        "vehicle_reg": "Vehicle Reg. No."
      },
      "units": {
        "kg": "kg",
        "pcs": "pcs"
      }
    },
    "table_row": {
      "to_destination": "To destination",
      "to_warehouse": "To warehouse"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "pcs."
    },
    "index": {
      "active_title": "Active takeouts (in progress)",
      "cta": "Click on one or create a new one!",
      "historical_title": "Completed takeouts (last 50)",
      "new_takeout": "New Takeout",
      "no_active_takeouts": "There are no active takeouts.",
      "no_historical_takeouts": "No completed takeouts yet.",
      "no_takeouts": "There are no takeouts yet.",
      "type": "Takeout"
    },
    "new": {
      "add_destination": "Add",
      "choose_destination": "Choose work site",
      "choose_vehicle": "Choose vehicle",
      "destinations": "Work sites",
      "drag_to_reorder": "Drag to reorder",
      "mandatory_field": "This field is required"
    },
    "returns": {
      "p_text": "Click on the relevant takeout to perform the return",
      "return": "Return"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Available units:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Remaining units:",
      "title": "Discard All remaining Explosives"
    },
    "scan_takeout_explosives": {
      "title": "Take Out Selected Explosives"
    },
    "scanner": {
      "delete_takeout": "Delete takeout",
      "destination": "Site: %{destination}",
      "item_count": "Number of items: %{count}",
      "no_camera_alert": "Camera unavailable",
      "no_camera_subalert": "You might not have granted permission to use the camera",
      "scan_only_used_explosives": "Select <strong>only</strong> items used on site",
      "scanned": "Scanned:",
      "this_takeout": "this takeout",
      "title": "Package Code Scanning",
      "vehicle": "Vehicle: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Active",
      "date": "Date:",
      "destination": "Work Site:",
      "employee": "Responsible for takeout:",
      "inactive_takeout": "❌ - Inactive/Returned",
      "state": "Status:",
      "subtitle": "*The table can be scrolled horizontally on narrow mobile devices",
      "title": "Explosives Takeout/Return Overview",
      "title_2": "Taken-Out Explosive Items",
      "title_3": "Used explosive items are highlighted in red",
      "vehicle": "Vehicle:"
    },
    "table": {
      "button_edit_return": "Edit",
      "button_return_to_warehouse": "Return to warehouse",
      "button_take_out": "Take Out",
      "button_to_next_object": "To next object",
      "items": "%{count} items",
      "title": "Explosives %{action}"
    },
    "taken_explosives": {
      "no_person": "No responsible person assigned",
      "person": "Taken out by: %{name}",
      "title": "Taken-Out Items:",
      "unknown": "unknown"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "vehicles": {
    "edit": {
      "title": "Edit Vehicle"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Important to keep the license plate format"
    },
    "index": {
      "delete_modal_text": "vehicle %{number_plate}",
      "subtitle": "Management of vehicles able to carry explosives",
      "title": "Vehicles"
    },
    "new": {
      "title": "Add New Vehicle"
    }
  },
  "view": "View",
  "warehouses": {
    "edit": {
      "title": "Editing %{warehouse_name}"
    },
    "form": {
      "country_code_hint": "Use the ISO 3166-1 alpha-2 code, e.g. LV.",
      "latitude_hint": "Use the latitude, e.g. 56.96130.",
      "longitude_hint": "Use the longitude, e.g. 24.12540.",
      "responsible_person_prompt": "Choose a responsible person"
    },
    "index": {
      "subtitle": "Warehouse list and management",
      "title": "Warehouses"
    },
    "new": {
      "title": "Add New Warehouse"
    },
    "show": {
      "details_title": "Warehouse details",
      "explosives_title": "Explosives in warehouse",
      "map_title": "Location on map",
      "no_explosives": "No explosives are currently stored in this warehouse."
    }
  }
});
I18n.translations["ee"] = I18n.extend((I18n.translations["ee"] || {}), {
  "actions": "Actions",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Address",
        "name": "Name"
      },
      "employee": {
        "active": "Active",
        "admin": "Super-rights",
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "role": "Role"
      },
      "explosive": {
        "available": "Available",
        "box_number": "Box Number",
        "code": "Item Code",
        "delivery_date": "Delivery Date",
        "grouped_number": "Grouped number",
        "import_name": "Imported File Name",
        "item_number": "Item Number",
        "location": "Location",
        "manufacturer": "Manufacturer",
        "middlebox_number": "Package Number",
        "number_type": "Number type",
        "product_name": "Product Name",
        "product_number": "Product Number",
        "reason": "Reason",
        "takeout": "Takeout",
        "unknown_type": "Unknown type"
      },
      "item_setting": {
        "aine_code": "Substance Code",
        "countable_unit": "Countable Unit",
        "countable_units": {
          "units": "Units",
          "weight": "Weight"
        },
        "include_in_waybills": "Include in Waybills",
        "item_count": "Number of Items",
        "item_name_display": "Display Name",
        "item_name_import": "Item Name",
        "manually_created": "Manually Created",
        "set_weight_manually": "Manual Weight",
        "uro_number": "URO Number",
        "waybill_position": "Waybill Position",
        "weight": "Weight"
      },
      "log": {
        "action": "Action",
        "actions": {
          "atgriešana": "Return",
          "dzēšana": "Deletion",
          "izņemšana": "Takeout",
          "korekcija": "Correction",
          "noliktavas pārvietošana": "Warehouse transfer",
          "pievienošana": "Addition",
          "rediģēšana": "Editing",
          "saņemšana": "Data import",
          "starp-objektu pārvietošana": "Inter-object transfer"
        },
        "author": "Performed By",
        "corrected_explosives": "Corrected Explosives",
        "current_destination": "Current Location",
        "date": "Date",
        "destination": "Work Site",
        "destinations": "Work Sites",
        "employee": "Employee",
        "id_number": "ID Number",
        "import_name": "Import File",
        "notes": "Notes",
        "takeout": "Takeout",
        "takeout_waybill": "Takeout Waybill",
        "takeout_waybill_custom_items": "Manual Row in the Takeout Waybill",
        "vehicle": "Vehicle"
      },
      "pdf_code_printout": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "report": {
        "code": "Code",
        "name": "Name",
        "unit": "Unit of Measure",
        "weight": "Weight"
      },
      "takeout": {
        "active": "Active?",
        "date": "Date",
        "destination": "Work Site",
        "employee": "Creator",
        "removed": "Removed",
        "vehicle": "Vehicle",
        "waybills": "Waybills"
      },
      "takeout_waybill": {
        "date": "Date",
        "destination": "Site",
        "direction": "Direction",
        "employee": "Employee",
        "initally_edited": "Edited",
        "issuance_person": "Issuance Person",
        "issuer": "Sender",
        "legal_entity": "Legal Entity",
        "number": "Number",
        "receiver": "Receiver",
        "receiving_person": "Receiving Person",
        "route": "Route",
        "scope": "Waybill scope",
        "takeout": "Takeout",
        "to_object": "To Site",
        "vehicle": "Vehicle"
      },
      "takeout_waybill_custom_item": {
        "amount": "Quantity",
        "item_setting": "Item Settings",
        "name": "Name",
        "package_name": "Package",
        "takeout_waybill": "Takeout Waybill",
        "weight": "Weight"
      },
      "user": {
        "confirmation_sent_at": "Confirmation sent at",
        "confirmation_token": "Confirmation token",
        "confirmed_at": "Confirmed at",
        "created_at": "Created at",
        "current_password": "Current password",
        "current_sign_in_at": "Current sign in at",
        "current_sign_in_ip": "Current sign in IP",
        "email": "Email",
        "encrypted_password": "Encrypted password",
        "failed_attempts": "Failed attempts",
        "last_sign_in_at": "Last sign in at",
        "last_sign_in_ip": "Last sign in IP",
        "locked_at": "Locked at",
        "password": "Password",
        "password_confirmation": "Password confirmation",
        "remember_created_at": "Remember created at",
        "remember_me": "Remember me",
        "reset_password_sent_at": "Reset password sent at",
        "reset_password_token": "Reset password token",
        "sign_in_count": "Sign in count",
        "unconfirmed_email": "Unconfirmed email",
        "unlock_token": "Unlock token",
        "updated_at": "Updated at"
      },
      "vehicle": {
        "active": "Active",
        "number_plate": "License Plate"
      },
      "warehouse": {
        "address": "Address",
        "city": "City",
        "country_code": "Country Code",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "name": "Name",
        "responsible_employee": "Responsible Person",
        "zip": "Postal Code"
      }
    },
    "created_at": "Created",
    "errors": {
      "destination": {
        "adress_taken": "Address has already been taken",
        "generic_error": "Error in input data",
        "name_blank": "Name can't be blank"
      },
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Employee already has identical takeout",
        "missing_destinations": "Must have at least one destination"
      },
      "takeout_waybill": {
        "destination_unknown": "Unknown"
      }
    },
    "models": {
      "destination": "Work Site",
      "employee": "Employee",
      "explosive": "Explosive",
      "item_setting": "Item Setting",
      "log": "Activity Log",
      "pdf_code_printout": "PDF Code Printout",
      "report": "Report",
      "takeout": "Explosives Takeout",
      "takeout_waybill": "Waybill",
      "takeout_waybill_custom_item": "Manually Entered Item",
      "user": {
        "one": "User",
        "other": "Users"
      },
      "vehicle": "Vehicle",
      "warehouse": "Warehouse"
    },
    "removed": "Removed",
    "updated_at": "Updated"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Back to login",
        "description": "Choose a new password for your account.",
        "password_confirmation_label": "Confirm new password",
        "password_label": "New password",
        "submit": "Update password",
        "title": "Set your password"
      },
      "new": {
        "back_to_login": "Back to login",
        "description": "Enter your work email to receive a password setup link.",
        "submit": "Send link",
        "title": "Request password link"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "or",
        "email_login_button": "Email login",
        "email_login_title": "Email login with your work email",
        "google_auth": "Log In with Google",
        "password_label": "Password",
        "password_link_text": "Request password link",
        "remember_me": "Remember me",
        "title": "Log In to BALROCK Warehouse Management"
      }
    }
  },
  "back": "Back",
  "cancel": "Cancel",
  "controllers": {
    "application": {
      "not_logged_in": "You must log in to view the requested page!",
      "not_permitted": "You do not have permission to view the requested page!",
      "report_ready": "Your report: %{report_name} is ready! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Invalid email or password. Please check your details.",
        "no_access": "Your access to the system is denied. Contact the administration.",
        "server_error": "A server error occurred. Please try again."
      }
    },
    "destinations": {
      "object_added": "Object successfully added",
      "object_edited": "Object successfully edited"
    },
    "employees": {
      "employee_added": "Employee successfully added",
      "employee_added_with_invite": "Employee added and password setup email sent",
      "employee_edited": "Employee data successfully updated",
      "password_email_failed": "Employee added, but sending the password setup email failed."
    },
    "explosives": {
      "all_items_moved": "All selected items successfully moved",
      "all_items_removed": "All units successfully removed",
      "all_items_returned": "All units successfully returned to storage",
      "database_updated": "Database updated",
      "failed_import_file_count": "%{count_failed} out of %{count_total} failed to import",
      "failed_to_add": "%{count} units failed to be added",
      "failed_to_import": "Failed to import file %{filename} because %{reason}",
      "import_in_progress": "Import in progress. You will be notified of the result.",
      "item_already_at_destination": "already at destination",
      "item_not_found": "not found",
      "item_removed": "removed",
      "item_unavailable": "unavailable",
      "multiple_warehouses": "Error! Scanned units are located in multiple warehouses, please clarify their numbers.",
      "no_files_selected": "No files selected",
      "no_item_settings": "Some units are not linked to settings",
      "no_items_found": "No items were found in the given number range",
      "no_warehouse": "--",
      "not_all_items_moved": "An error occurred while moving units; please check the item list.",
      "not_all_states_changed": "An error occurred, and some unit statuses did not change",
      "not_available_for_movement": "Explosive item is not available",
      "partial_items_moved": "Successfully moved %{moved} selected items. %{failed} selected items failed (e.g. %{examples}).",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "range_too_large": "Range is too large (max %{max} items)",
      "warehouse_not_selected": "No destination warehouse selected"
    },
    "item_settings": {
      "created": "Unit settings successfully created",
      "deleted": "Unit settings successfully deleted",
      "edited": "Unit settings successfully updated",
      "failed_to_create": "Error creating unit settings",
      "failed_to_edit": "Error updating unit settings",
      "unable_to_delete": "Cannot delete because it is linked to explosives"
    },
    "reports": {
      "error": "An error occurred. Please try to generate the report again!",
      "no_period": "Specify the explosives movement report period!",
      "no_report": "Report file not found!",
      "preparation_error": "An error occurred while preparing report %{report_name}"
    },
    "sessions": {
      "invalid_credentials": "Invalid email or password. Please check your details.",
      "no_access": "Your access to the system is denied. Contact the administration.",
      "server_error": "A server error occurred. Please try again."
    },
    "takeout_waybills": {
      "data_updated": "Waybill data updated",
      "waybill_edited": "Waybill already edited"
    },
    "takeouts": {
      "add_back_to_warehouse": "Place the units back in the correct warehouse!",
      "item_not_removed": "Error, failed to remove unit",
      "item_removed": "Unit successfully removed",
      "need_more_data": "Please specify waybill details",
      "no_access": "You do not have access rights",
      "no_access_system_error": "A system error occurred related to your access authorization",
      "scan_to_next_object_title": "Scan units to take to %{destination}",
      "takeout_confirmation_modal_title": "Are you sure you want to go to %{destination} with the units:",
      "takeout_exists": "Error! Such a takeout already exists!",
      "takeout_unavailable": "Takeout unavailable",
      "to_next_object_button": "Move to %{destination}"
    },
    "vehicles": {
      "created": "Vehicle successfully added",
      "edited": "Vehicle successfully edited"
    },
    "warehouses": {
      "unable_to_delete": "Failed to delete the warehouse",
      "warehouse_created": "Warehouse successfully created",
      "warehouse_deleted": "Warehouse successfully deleted",
      "warehouse_edited": "Warehouse data successfully updated"
    }
  },
  "create": "Create",
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "delete": "Delete",
  "destinations": {
    "edit": {
      "title": "Edit Site"
    },
    "form": {
      "adress_note": "The address must be unique.",
      "adress_placeholder": "Site address",
      "name_placeholder": "Site name"
    },
    "new": {
      "title": "Add New Site"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Your email address has been successfully confirmed.",
      "new": {
        "resend_confirmation_instructions": "Resend confirmation instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
    },
    "failure": {
      "already_authenticated": "You are already signed in.",
      "inactive": "Your account is not activated yet.",
      "invalid": "Invalid %{authentication_keys} or password.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Your account is locked.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Your session expired. Please sign in again to continue.",
      "unauthenticated": "You need to sign in or sign up before continuing.",
      "unconfirmed": "You have to confirm your email address before continuing."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Confirm my account",
        "greeting": "Welcome %{recipient}!",
        "instruction": "You can confirm your account email through the link below:",
        "subject": "Confirmation instructions"
      },
      "email_changed": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your email has been changed to %{email}.",
        "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
        "subject": "Email Changed"
      },
      "password_change": {
        "greeting": "Hello %{recipient}!",
        "message": "We're contacting you to notify you that your password has been changed.",
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "action": "Change my password",
        "greeting": "Hello %{recipient}!",
        "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
        "instruction_2": "If you didn't request this, please ignore this email.",
        "instruction_3": "Your password won't change until you access the link above and create a new one.",
        "subject": "Reset password instructions"
      },
      "unlock_instructions": {
        "action": "Unlock my account",
        "greeting": "Hello %{recipient}!",
        "instruction": "Click the link below to unlock your account:",
        "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
        "subject": "Unlock instructions"
      }
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "change_my_password": "Change my password",
        "change_your_password": "Change your password",
        "confirm_new_password": "Confirm new password",
        "new_password": "New password"
      },
      "new": {
        "forgot_your_password": "Forgot your password?",
        "send_me_reset_password_instructions": "Send me reset password instructions"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Your password has been changed successfully. You are now signed in.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
      "edit": {
        "are_you_sure": "Are you sure?",
        "cancel_my_account": "Cancel my account",
        "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
        "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
        "title": "Edit %{resource}",
        "unhappy": "Unhappy?",
        "update": "Update",
        "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
      },
      "new": {
        "sign_up": "Sign up"
      },
      "signed_up": "Welcome! You have signed up successfully.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Your account has been updated successfully.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "sign_in": "Log in"
      },
      "signed_in": "Signed in successfully.",
      "signed_out": "Signed out successfully."
    },
    "shared": {
      "links": {
        "back": "Back",
        "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
        "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
        "forgot_your_password": "Forgot your password?",
        "sign_in": "Log in",
        "sign_in_with_provider": "Sign in with %{provider}",
        "sign_up": "Sign up"
      },
      "minimum_password_length": {
        "one": "(%{count} character minimum)",
        "other": "(%{count} characters minimum)"
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": "Resend unlock instructions"
      },
      "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
    }
  },
  "download": "Download",
  "edit": "Edit",
  "edit_object": "Edit",
  "employees": {
    "edit": {
      "title": "Edit Employee"
    },
    "form": {
      "email_note": "Must be a @gmail.com or @balrock.lv email.",
      "email_placeholder": "Enter the employee’s email",
      "first_name_note": "The first name cannot contain digits.",
      "first_name_placeholder": "Enter the employee’s first name",
      "last_name_note": "The last name cannot contain digits.",
      "last_name_placeholder": "Enter the employee’s last name"
    },
    "index": {
      "employee_enabled": "System access",
      "subtitle": "Employee and access management",
      "title": "Employees"
    },
    "new": {
      "title": "Add New Employee"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "was already confirmed, please try signing in",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "has expired, please request a new one",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "not found",
      "not_locked": "was not locked",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    }
  },
  "explosive_unit": "Unit",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "subtitle": "Scan a code or enter a number and choose the next action",
      "title": "Explosive Quantity Correction"
    },
    "index": {
      "title": "Erroneous Records"
    },
    "location": {
      "removed": "-- (Manually Deleted)",
      "used": "Used - %{destination_name}",
      "warehouse": "Warehouse"
    },
    "new": {
      "drop_files": "Drop files here",
      "import": "Import",
      "upload_note": "Choose one or more .xml or .xlsx files."
    },
    "warehouse_movement": {
      "entry_mode_label": "Entry mode",
      "no_camera_alert": "Camera unavailable!",
      "no_camera_alert_message": "You might not have granted permission or JavaScript is disabled.",
      "process_range": "Process Range",
      "range_end": "Range End",
      "range_end_placeholder": "e.g. 275998",
      "range_entry": "Range Entry",
      "range_entry_title": "Range entry:",
      "range_start": "Range Start",
      "range_start_placeholder": "e.g. 275961",
      "single_entry": "Single Entry",
      "subtitle": "Choose the destination warehouse, then scan a code or enter a number",
      "title": "Move Explosives Between Warehouses",
      "warehouse_select_label": "Destination warehouse",
      "warehouse_select_placeholder": "Choose a warehouse"
    }
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e6177b8 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/common_pluralizations/one_other.rb:7 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Item weight and waybill settings",
      "title": "Item Settings"
    },
    "item_setting_row": {
      "weight_note": "Default weight"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Error!"
    },
    "correction_code_scanner": {
      "camera_alert": "Camera unavailable!",
      "correction_modal_title": "Quantity Correction",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "no_camera_permission": "You may not have granted permission or JavaScript is disabled.",
      "remove_explosives": "Delete from warehouse",
      "revive_explosives": "Return to inventory (no warehouse)",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "which_has": ", which has "
    },
    "file_upload": {
      "files_selected": " files selected",
      "import_notification": "Data is being imported, please wait."
    },
    "item_settings": {
      "success": "Success"
    },
    "loading_screen": {
      "please_wait": "Please wait..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Add selected items",
      "already_scanned": "Code already scanned",
      "camera_off": "Camera off!",
      "confirm_scanned_items": "I confirm that the scanned items and their statuses are correct",
      "confirm_used_items": "I confirm that all taken-out items were used on site",
      "error_occurred": "An error occurred",
      "failed_to_remove_item": "Error removing item. Try again or contact the administrator!",
      "item_already_scanned": "Item(s) already scanned.",
      "item_returnable": "Returnable",
      "item_used": "Used",
      "items_return_confirmation": "Do you want to return the following items?",
      "items_take_confirmation": "Do you want to take out the following items?",
      "no_items_scanned": "No items scanned",
      "range_modal_title": "Add items from range",
      "refresh_for_camera": "To turn the camera back on, please refresh the page!",
      "return_scanned": "The scanned items will be considered returned to the warehouse.",
      "scan_returnable_items": "Scanning returned items",
      "scan_used_items": "Used item scanning mode",
      "writeoff_scanned": "The scanned items will be considered used at the site. !! All taken-out items in the same package as the scanned item will be returned !!"
    },
    "warehouse_movement": {
      "confirm_move": "Confirm Move",
      "current_warehouse_name": "Warehouse",
      "explosive_type": "Explosive",
      "explosive_units": "items",
      "from_warehouse": "From %{warehouse}",
      "included_ids": "Included IDs (%{included} / %{total})",
      "items_badge": "%{count} Items",
      "modal_title": "Move Explosives Between Warehouses",
      "modal_title_short": "Move Explosives",
      "move_error": "An error occurred while moving items; please check the item list.",
      "move_success": "Explosives moved successfully",
      "move_to_button": "Move",
      "move_warehouse_info": "Move from #{from} to #{to}",
      "no_items_found": "No items were found in the given number range",
      "no_items_selected": "Select at least one item to move",
      "range_failures_preview": "%{count} items cannot be moved (e.g. %{examples}).",
      "range_label": "Range: %{start} → %{end}",
      "range_must_be_numeric": "Range start and end must be numeric",
      "range_required": "Enter both range start and range end",
      "range_start_after_end": "Range start must be less than or equal to range end",
      "some_units_deleted": "but some of the items in it have already been deleted.",
      "subtitle_range": "Choose the destination warehouse, then enter or scan a number range",
      "to_warehouse": "To %{warehouse}",
      "total_items": "%{count} Items",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "No destination warehouse selected",
      "which_has": ", which has "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Got it",
      "confirmation": "Please confirm.",
      "title": "Error!"
    },
    "application": {
      "title": "Balrock Warehouse Management"
    },
    "camera_switch": {
      "use_camera": "Use Camera"
    },
    "confirmation_modal": {
      "confirm": "Confirm",
      "confirmation": "Have you used all the taken-out items?",
      "title": "Confirmation"
    },
    "delete_modal": {
      "confirmation": "Are you sure you want to delete %{deletable_object}?",
      "title": "Delete Confirmation"
    },
    "external_scanner": {
      "item_number_placeholder": "Manual number entry",
      "search": "Search",
      "title": "Manual entry or external scanner:"
    },
    "loading_overlay": {
      "please_wait": "Please wait..."
    },
    "sidebar": {
      "additional_code_printouts": "Additional Code Printing",
      "back": "Back",
      "correction": "Amount Correction",
      "home": "Home",
      "language": "Language",
      "logout": "Log Out",
      "logs": "Event List",
      "menu": "Menu",
      "receive_explosives": "Receive",
      "reports": "Reports",
      "return": "Return",
      "settings": {
        "destinations": "Sites",
        "employees": "Employees",
        "item_settings": "Item Settings",
        "title": "Settings",
        "vehicles": "Vehicles"
      },
      "takeout": "Take Out",
      "title": "Balrock Explosives Warehouse",
      "warehouse_movement": "Warehouse Movement",
      "warehouses": "Warehouses",
      "waybills": "Waybills"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Consolidated report (all warehouses)",
      "description": "Please select which warehouses to include in the report:",
      "prepare_report": "Prepare Report",
      "title": "Select Warehouses"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Number of corrected items:",
      "corrected_explosives_table": "Corrected Explosives",
      "correction_action": "Correction action:",
      "correction_date": "Date:",
      "deletion": "❌ Deletion",
      "employee": "Correction performed by:",
      "return": "✅ Returned to warehouse",
      "title": "Explosive Corrections Report"
    },
    "helper_row": {
      "changes": "Changes",
      "corrected_explosives_count": "Number of corrected explosives",
      "correction_action": "Correction action",
      "deletion": "Deletion",
      "edited": "Edited",
      "edited_object": "Edited item",
      "error": "Something went wrong",
      "imported_explosives_count": "Number of added explosives",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "movement_route": "Movement route",
      "precise_time": "Precise time",
      "return": "Return to warehouse",
      "returned_explosives_count": "Number of returned explosives",
      "taken_explosives_count": "Number of taken-out explosives",
      "takeout_responsible_employee": "Person responsible for takeout (creator)",
      "to_overview": "To overview",
      "used_explosives_count": "Used explosives count",
      "used_explosives_weight": "Used explosives weight"
    },
    "index": {
      "filtering": "Filtering",
      "subtitle": "Events are sorted in descending order by date",
      "title": "Activity Log"
    },
    "log_querry": {
      "clear_filters": "Clear Filters",
      "filter": "Filter"
    },
    "log_table": {
      "no_results": "Nothing found matching the given criteria"
    },
    "warehouse_moved_explosives": {
      "employee": "Moved by:",
      "moved_between": "Moved between",
      "moved_explosives_count": "Moved items count",
      "moved_explosives_table": "Moved explosives",
      "movement_date": "Date:",
      "title": "Explosives moved between warehouses"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Active explosives takeouts:",
      "current_employee": "User:",
      "employee_admin": "Administrator",
      "employee_regular": "Employee",
      "employee_role": "Status:",
      "explosives_in_warehouse": "Number of explosives in warehouse:",
      "no_actions": "You have not performed any actions yet.",
      "previous_actions": "Your latest actions:",
      "title": "Balrock Explosives Warehouse Management"
    }
  },
  "new_object": "Add",
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Billion",
            "other": "Billion"
          },
          "million": {
            "one": "Million",
            "other": "Million"
          },
          "quadrillion": {
            "one": "Quadrillion",
            "other": "Quadrillion"
          },
          "thousand": {
            "one": "Thousand",
            "other": "Thousand"
          },
          "trillion": {
            "one": "Trillion",
            "other": "Trillion"
          },
          "unit": {
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x00007fc57e632c70 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x00007fc57e632c98 /usr/local/bundle/gems/activesupport-6.1.7.10/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Page %{page_input} of %{pages}",
    "info": {
      "multiple_pages": "Displaying %{item_name} <b>%{from}-%{to}</b> of <b>%{count}</b> in total",
      "no_items": "No %{item_name} found",
      "single_page": "Displaying <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Record",
      "other": "Records"
    },
    "items_selector_js": "Include %{items_input} %{item_name} records on the page",
    "nav": {
      "gap": "&hellip;",
      "next": "Next&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Previous"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Failed to create printable codes",
      "invalid_code_type": "Invalid item code type"
    },
    "index": {
      "no_results": "Nothing found",
      "package_search": "Search for boxes of items to print by name",
      "package_search_placeholder": "Name or part of it",
      "search": "Search",
      "title": "Duplicate Item Code Printing"
    },
    "table_row": {
      "get_pdf": "Get PDF code sheet"
    }
  },
  "remove": "Remove",
  "reports": {
    "index": {
      "available_explosives_count": "Currently, %{count} items are available",
      "available_explosives_report": "Available Explosives",
      "date_range": "Time Period",
      "explosive_movement_report": "Explosive Movement within a Time Period",
      "explosive_summary": "Explosive Stock in Warehouse by Name",
      "explosives_in_warehouse": "Currently in the warehouse:",
      "prepare_report": "Prepare",
      "tab_all": "All",
      "tab_without_warehouse": "Without warehouse",
      "title": "Available System Reports (.xlsx)"
    },
    "quick_report_tab": {
      "total_amount": "Total:",
      "units": "Units",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Location",
              "Responsible"
            ],
            "no_employee": "No responsible person assigned",
            "report_row_title": "Overview of Available Explosives %{date}",
            "report_warehouse_row_title": "Overview of Available Explosives in Warehouse %{warehouse} - %{date}",
            "warehouse_headers": [
              "Code",
              "Manufacturer",
              "Name",
              "Box Number",
              "Package Number",
              "Item Number",
              "URO Number",
              "AINE Code",
              "Import File",
              "Responsible"
            ],
            "worksheet_title": "Available Explosives"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "ActiveTakeout-%{index}-%{date}",
              "returned": "ReturnedTakeout-%{index}-%{date}"
            },
            "states": {
              "active": "taken out",
              "returned": "returned",
              "used": "used"
            },
            "takeout_explosives_headers": [
              "Code",
              "Name",
              "Box",
              "Package",
              "Explosive",
              "Import File",
              "Status"
            ],
            "takeout_info_headers": [
              "Employee",
              "Work Site",
              "Vehicle",
              "Status",
              "Number of Taken-Out Items",
              "Number of Used Items"
            ],
            "worksheet_title": "Explosives Takeout/Return Report"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Driver",
    "employee": "Employee",
    "manager": "Manager"
  },
  "save": "Save",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "All units successfully written off!",
        "failed_to_return": "{count} units could not be returned.",
        "returned": "Units successfully returned!",
        "server_error": "Server error returning units!"
      },
      "take_explosives": {
        "failed_to_take": "{count} units could not be taken.",
        "server_error": "Server error taking units!",
        "success": "Units successfully taken"
      },
      "type": "Explosive"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Add to warehouse",
      "expand": "Expand",
      "title": "Explosives without warehouse"
    }
  },
  "state": "Enabled",
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Waybill FROM",
    "button_title_to": "Waybill TO",
    "custom_item_form_row": {
      "not_included_in_waybill": "This item is not included in the waybill"
    },
    "edit": {
      "manual_items": "Manually Enterable Items",
      "title": "Editing Waybill %{number}",
      "view_waybill": "View Waybill",
      "waybill_persons": "Waybill Persons"
    },
    "index": {
      "subtitle": "List of all created waybills",
      "title": "Waybills"
    },
    "pdf": {
      "default_packaging_type": "cardboard box",
      "failed_to_create": "Failed to create waybill",
      "header": {
        "date": "Date",
        "route": "Route",
        "waybill": "Waybill",
        "waybill_nr": "WAYBILL No."
      },
      "item_counts": {
        "kogus": "Quantity",
        "laohoidja": "Warehouse keeper:",
        "seeria_nr": "Taken:",
        "tagastus": "Return:",
        "vedaja_lohkaja": "Carrier/Blaster/Blast master:",
        "veokiri_nr": "WAYBILL nr:"
      },
      "legal_entity": {
        "address": "Address",
        "reg_number": "Reg. No.",
        "title": "Legal Entity",
        "vat_number": "VAT Reg. No."
      },
      "no_custom_item_data": "Failed to create waybill because all items in it do not have a specified weight",
      "sender_receiver": "Sender/Receiver:",
      "signatures": {
        "carrier_received": "Substance received by carrier:",
        "carrier_returned": "Substance remainder returned by carrier to warehouse keeper:",
        "carrier_title": "Carrier:",
        "date": "Date:",
        "issuer_title": "Persons responsible for goods issuance:",
        "miner_received": "Substance received from carrier by miner:",
        "miner_returned": "Substance remainder returned by miner to carrier:",
        "name": "Name, Surname:",
        "name_signature_date": "name, signature, date",
        "receiver_title": "Persons responsible for goods receipt:",
        "responsible_title": "Responsible person:",
        "signature": "Signature:",
        "warehouse_keeper_issued": "Waybill prepared and substance issued by warehouse keeper",
        "warehouse_keeper_received": "Substance remainder received by warehouse keeper:"
      },
      "table": {
        "aine_code": "Substance code",
        "consumption": "Consumption\nkg/pcs/m",
        "description": "Description",
        "name": "Name",
        "package_count": "Package count (pcs.)",
        "packaging": "Packaging",
        "quantity": "Quantity (pcs.)",
        "remainder": "Remainder\nkg/pcs/m",
        "source_warehouse": "Warehouse",
        "substance_code": "Substance code",
        "substance_name_description": "Substance name and description",
        "taken": "Taken\nkg/pcs/m",
        "total": "Total:",
        "total_weight": "Total weight (kg):",
        "uro_number": "URO No.",
        "weight_kg": "Weight (kg)"
      },
      "total_cargo": "Total cargo:",
      "transport": {
        "self_transport": "self-transport",
        "type": "Transport type",
        "vehicle_reg": "Vehicle Reg. No."
      },
      "units": {
        "kg": "kg",
        "pcs": "pcs"
      }
    },
    "table_row": {
      "to_destination": "To destination",
      "to_warehouse": "To warehouse"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "pcs."
    },
    "index": {
      "active_title": "Active takeouts (in progress)",
      "cta": "Click on one or create a new one!",
      "historical_title": "Completed takeouts (last 50)",
      "new_takeout": "New Takeout",
      "no_active_takeouts": "There are no active takeouts.",
      "no_historical_takeouts": "No completed takeouts yet.",
      "no_takeouts": "There are no takeouts yet.",
      "type": "Takeout"
    },
    "new": {
      "add_destination": "Add",
      "choose_destination": "Choose work site",
      "choose_vehicle": "Choose vehicle",
      "destinations": "Work sites",
      "drag_to_reorder": "Drag to reorder",
      "mandatory_field": "This field is required"
    },
    "returns": {
      "p_text": "Click on the relevant takeout to perform the return",
      "return": "Return"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Available units:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Remaining units:",
      "title": "Discard All remaining Explosives"
    },
    "scan_takeout_explosives": {
      "title": "Take Out Selected Explosives"
    },
    "scanner": {
      "delete_takeout": "Delete takeout",
      "destination": "Site: %{destination}",
      "item_count": "Number of items: %{count}",
      "no_camera_alert": "Camera unavailable",
      "no_camera_subalert": "You might not have granted permission to use the camera",
      "scan_only_used_explosives": "Select <strong>only</strong> items used on site",
      "scanned": "Scanned:",
      "this_takeout": "this takeout",
      "title": "Package Code Scanning",
      "vehicle": "Vehicle: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Active",
      "date": "Date:",
      "destination": "Work Site:",
      "employee": "Responsible for takeout:",
      "inactive_takeout": "❌ - Inactive/Returned",
      "state": "Status:",
      "subtitle": "*The table can be scrolled horizontally on narrow mobile devices",
      "title": "Explosives Takeout/Return Overview",
      "title_2": "Taken-Out Explosive Items",
      "title_3": "Used explosive items are highlighted in red",
      "vehicle": "Vehicle:"
    },
    "table": {
      "button_edit_return": "Edit",
      "button_return_to_warehouse": "Return to warehouse",
      "button_take_out": "Take Out",
      "button_to_next_object": "To next object",
      "items": "%{count} items",
      "title": "Explosives %{action}"
    },
    "taken_explosives": {
      "no_person": "No responsible person assigned",
      "person": "Taken out by: %{name}",
      "title": "Taken-Out Items:",
      "unknown": "unknown"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "vehicles": {
    "edit": {
      "title": "Edit Vehicle"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Important to keep the license plate format"
    },
    "index": {
      "delete_modal_text": "vehicle %{number_plate}",
      "subtitle": "Management of vehicles able to carry explosives",
      "title": "Vehicles"
    },
    "new": {
      "title": "Add New Vehicle"
    }
  },
  "view": "View",
  "warehouses": {
    "edit": {
      "title": "Editing %{warehouse_name}"
    },
    "form": {
      "country_code_hint": "Use the ISO 3166-1 alpha-2 code, e.g. LV.",
      "latitude_hint": "Use the latitude, e.g. 56.96130.",
      "longitude_hint": "Use the longitude, e.g. 24.12540.",
      "responsible_person_prompt": "Choose a responsible person"
    },
    "index": {
      "subtitle": "Warehouse list and management",
      "title": "Warehouses"
    },
    "new": {
      "title": "Add New Warehouse"
    },
    "show": {
      "details_title": "Warehouse details",
      "explosives_title": "Explosives in warehouse",
      "map_title": "Location on map",
      "no_explosives": "No explosives are currently stored in this warehouse."
    }
  }
});
